import styled from "@emotion/styled";
import React, { memo } from "react";
import theme from "../../theme";
import { keyframes } from "@emotion/react";

export const ShowPwIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99992 0.75C5.83325 0.75 2.27492 3.34167 0.833252 7C2.27492 10.6583 5.83325 13.25 9.99992 13.25C14.1666 13.25 17.7249 10.6583 19.1666 7C17.7249 3.34167 14.1666 0.75 9.99992 0.75ZM9.99992 11.1667C7.69992 11.1667 5.83325 9.3 5.83325 7C5.83325 4.7 7.69992 2.83333 9.99992 2.83333C12.2999 2.83333 14.1666 4.7 14.1666 7C14.1666 9.3 12.2999 11.1667 9.99992 11.1667ZM9.99992 4.5C8.61659 4.5 7.49992 5.61667 7.49992 7C7.49992 8.38333 8.61659 9.5 9.99992 9.5C11.3833 9.5 12.4999 8.38333 12.4999 7C12.4999 5.61667 11.3833 4.5 9.99992 4.5Z"
        fill={theme.color.neutral_300}
      />
    </svg>
  );
});

export const HidePwIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 3.35954L3.3593 2.50024L17.5 16.641L16.6407 17.5003L2.5 3.35954ZM10.1305 7.50349L12.4966 9.8695C12.4637 9.25266 12.2039 8.66977 11.7671 8.23297C11.3303 7.79618 10.7474 7.53636 10.1305 7.50349ZM9.86961 12.4965L7.50359 10.1304C7.53646 10.7473 7.79629 11.3302 8.23308 11.767C8.66987 12.2038 9.25277 12.4636 9.86961 12.4965Z"
        fill={theme.color.neutral_300}
      />
      <path
        d="M10 13.75C9.42309 13.75 8.85396 13.617 8.33688 13.3611C7.8198 13.1053 7.36872 12.7336 7.01873 12.275C6.66874 11.8164 6.42928 11.2832 6.31899 10.7169C6.20869 10.1507 6.23053 9.5666 6.38281 9.01016L3.68477 6.31172C2.58281 7.32109 1.53281 8.63828 0.625 10C1.65703 11.7188 3.06875 13.4859 4.53906 14.4992C6.22578 15.6609 8.05977 16.25 9.99062 16.25C11.0458 16.2507 12.0931 16.0683 13.0859 15.7109L10.9918 13.6172C10.6686 13.7056 10.3351 13.7503 10 13.75ZM10 6.25C10.5769 6.24997 11.146 6.38305 11.6631 6.63888C12.1802 6.8947 12.6313 7.26639 12.9813 7.725C13.3313 8.18361 13.5707 8.71679 13.681 9.28306C13.7913 9.84932 13.7695 10.4334 13.6172 10.9898L16.3773 13.75C17.516 12.7246 18.5676 11.3453 19.375 10C18.3445 8.30352 16.918 6.54062 15.4227 5.51484C13.7148 4.34375 11.8871 3.75 9.99062 3.75C8.94704 3.7515 7.91223 3.94057 6.93555 4.3082L9.01016 6.38281C9.33269 6.29453 9.6656 6.24986 10 6.25Z"
        fill={theme.color.neutral_300}
      />
    </svg>
  );
});

export const CheckBoxIcon: React.FC<{ color?: string }> = memo(
  ({ color = theme.color.neutral_300 }) => {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="19" height="19" rx="3" fill={color} />
        <path
          d="M5.1665 9.5L8.4165 12.75L13.8332 6.25"
          stroke="white"
          strokeWidth="1.91667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

//사고 관제 아이콘
export const TracktorIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width, height, fill = theme.color.neutral_200 }) => {
  return (
    <svg
      width={width ? width : 156}
      height={height ? height : 124}
      viewBox="0 0 156 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M128.7 81.5607C116.854 81.5607 107.25 91.0614 107.25 102.78C107.25 114.5 116.854 124 128.7 124C140.546 124 150.15 114.5 150.15 102.78C150.15 91.0614 140.546 81.5607 128.7 81.5607ZM128.7 108.568C125.475 108.568 122.85 105.971 122.85 102.78C122.85 99.5903 125.475 96.9933 128.7 96.9933C131.925 96.9933 134.55 99.5903 134.55 102.78C134.55 105.971 131.925 108.568 128.7 108.568ZM148.2 39.1213H132.6V29.4278C132.6 26.023 133.746 22.7339 135.805 20.0622C136.883 18.6636 136.671 16.6718 135.484 15.3625L130.211 9.53431C128.588 7.73787 125.746 7.86567 124.191 9.72239C119.579 15.225 117 22.1962 117 29.4278V39.1213H92.0571L78.3851 7.56666C77.487 5.48045 75.9882 3.7018 74.0754 2.45233C72.1627 1.20286 69.9206 0.537809 67.6284 0.540045H35.1C28.6479 0.540045 23.4 5.73164 23.4 12.1144V47.4452C21.2964 45.8224 18.291 45.8875 16.3581 47.7997L8.775 55.3014C6.68119 57.3727 6.68119 60.7317 8.775 62.803L10.0084 64.0231C8.79206 66.256 7.82437 68.5613 7.10531 70.9485H5.3625C2.40094 70.9485 0 73.3236 0 76.2534V86.8633C0 89.793 2.40094 92.1682 5.3625 92.1682H7.10287C7.82437 94.5578 8.78963 96.8606 10.0059 99.0959L8.77256 100.316C6.67875 102.387 6.67875 105.746 8.77256 107.818L16.3556 115.319C18.4494 117.391 21.8449 117.391 23.9387 115.319L25.1721 114.099C27.4292 115.302 29.7594 116.26 32.1726 116.971V118.695C32.1726 121.625 34.5735 124 37.5351 124H48.2601C51.2216 124 53.6226 121.625 53.6226 118.695V116.974C56.0357 116.262 58.3659 115.305 60.6231 114.102L61.8564 115.322C63.9502 117.393 67.3457 117.393 69.4395 115.322L77.0226 107.82C79.1164 105.749 79.1164 102.39 77.0226 100.318L75.7892 99.0984C77.0055 96.8655 77.9732 94.5602 78.6923 92.173H80.4375C83.3991 92.173 85.8 89.7979 85.8 86.8681V85.4213H105.432C110.772 78.4308 119.16 73.8469 128.7 73.8469C133.243 73.8469 137.492 74.9585 141.326 76.7887L153.714 64.5343C155.176 63.0876 155.998 61.1247 155.998 59.0775V46.8376C156 42.5768 152.507 39.1213 148.2 39.1213ZM42.9 100.851C32.1311 100.851 23.4 92.214 23.4 81.5607C23.4 70.9075 32.1311 62.2701 42.9 62.2701C53.6689 62.2701 62.4 70.9075 62.4 81.5607C62.4 92.214 53.6689 100.851 42.9 100.851ZM48.2625 39.1213H39V15.9726H65.0544L75.0847 39.1213H48.2625Z"
        fill={fill}
      />
    </svg>
  );
});

// 소유자 관리 아이콘
export const AdminIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 173, height = 173, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_726_35256)">
          <path
            d="M117.812 65.625C117.812 73.9296 114.514 81.8941 108.641 87.7663C102.769 93.6385 94.8046 96.9375 86.5 96.9375C78.1954 96.9375 70.231 93.6385 64.3587 87.7663C58.4865 81.8941 55.1875 73.9296 55.1875 65.625C55.1875 57.3204 58.4865 49.356 64.3587 43.4837C70.231 37.6115 78.1954 34.3125 86.5 34.3125C94.8046 34.3125 102.769 37.6115 108.641 43.4837C114.514 49.356 117.812 57.3204 117.812 65.625Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 86.5C3 64.3544 11.7973 43.1159 27.4566 27.4566C43.1159 11.7973 64.3544 3 86.5 3C108.646 3 129.884 11.7973 145.543 27.4566C161.203 43.1159 170 64.3544 170 86.5C170 108.646 161.203 129.884 145.543 145.543C129.884 161.203 108.646 170 86.5 170C64.3544 170 43.1159 161.203 27.4566 145.543C11.7973 129.884 3 108.646 3 86.5ZM86.5 13.4375C72.7411 13.4382 59.262 17.324 47.6141 24.6477C35.9662 31.9713 26.623 42.4351 20.6599 54.8346C14.6967 67.2342 12.356 81.0656 13.9072 94.7368C15.4583 108.408 20.8382 121.363 29.4278 132.112C36.8384 120.171 53.1522 107.375 86.5 107.375C119.848 107.375 136.151 120.161 143.572 132.112C152.162 121.363 157.542 108.408 159.093 94.7368C160.644 81.0656 158.303 67.2342 152.34 54.8346C146.377 42.4351 137.034 31.9713 125.386 24.6477C113.738 17.324 100.259 13.4382 86.5 13.4375Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_726_35256">
            <rect
              width="167"
              height="167"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

export const AdminIcon2: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width = 173, height = 173, fill = theme.color.white }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 120"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M82.5 45C82.5 50.9674 80.1295 56.6903 75.9099 60.9099C71.6903 65.1295 65.9674 67.5 60 67.5C54.0326 67.5 48.3097 65.1295 44.0901 60.9099C39.8705 56.6903 37.5 50.9674 37.5 45C37.5 39.0326 39.8705 33.3097 44.0901 29.0901C48.3097 24.8705 54.0326 22.5 60 22.5C65.9674 22.5 71.6903 24.8705 75.9099 29.0901C80.1295 33.3097 82.5 39.0326 82.5 45Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 60C0 44.087 6.32141 28.8258 17.5736 17.5736C28.8258 6.32141 44.087 0 60 0C75.913 0 91.1742 6.32141 102.426 17.5736C113.679 28.8258 120 44.087 120 60C120 75.913 113.679 91.1742 102.426 102.426C91.1742 113.679 75.913 120 60 120C44.087 120 28.8258 113.679 17.5736 102.426C6.32141 91.1742 0 75.913 0 60ZM60 7.5C50.1133 7.50053 40.4277 10.2927 32.058 15.5552C23.6883 20.8177 16.9746 28.3366 12.6897 37.2465C8.40484 46.1563 6.7229 56.095 7.83749 65.9187C8.95208 75.7423 12.8179 85.0516 18.99 92.775C24.315 84.195 36.0375 75 60 75C83.9625 75 95.6775 84.1875 101.01 92.775C107.182 85.0516 111.048 75.7423 112.163 65.9187C113.277 56.095 111.595 46.1563 107.31 37.2465C103.025 28.3366 96.3117 20.8177 87.942 15.5552C79.5723 10.2927 69.8867 7.50053 60 7.5Z"
        fill={fill}
      />
    </svg>
  );
});

export const TracktorAndGlassIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width, height, fill = theme.color.neutral_200 }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="100 100 1000 1000"
      width={width ? width : 163}
      height={height ? height : 152}
    >
      <path
        fill={fill}
        stroke={theme.color.neutral_50}
        strokeMiterlimit={10}
        d="M841.7,727.3c-67,0-121.4,53.8-121.4,120.1c0,66.3,54.3,120.1,121.4,120.1S963,913.7,963,847.4
C963,781.1,908.7,727.3,841.7,727.3z M841.7,880.2c-18.2,0-33.1-14.7-33.1-32.8c0-18.1,14.9-32.7,33.1-32.7
c18.3,0,33.1,14.7,33.1,32.7C874.8,865.5,859.9,880.2,841.7,880.2z"
      />
      <path
        fill={fill}
        stroke={theme.color.neutral_50}
        strokeMiterlimit={10}
        d="M948.8,492.3h-88.3v-54.9c0-19.3,6.5-37.9,18.1-53c6.1-7.9,4.9-19.2-1.8-26.6l-29.8-33
c-9.2-10.2-25.3-9.4-34.1,1.1c-26.1,31.1-40.7,70.6-40.7,111.5v54.9H631.1L554.6,311c-5.1-11.8-13.6-21.9-24.4-28.9
c-7.9-5.2-44-5.2-53.3-6.7c30.1,56.7,32.5,119,21.2,151.4l36.9,65.6l-22.8-0.5l54.6,55.3l10.4,12.3c10.1,12.4,15.1,24.2,15.3,38.4
c0.2,12-6.5,26.4-22.5,42.4c-9.8,9.8-26.5,18.3-40.3,18.3c-13.9,0-32.3-7.9-44-19.3c0,0-11-10.1-11-10.1l-76.1-68.8
c-4.5,4.8-40.7,17.9-86.7,18.5c-33.5,0.4-51.4-0.9-119.5-23.7l-32.5,28.6c-11.8,11.7-11.8,30.7,0,42.5l7,6.9
c-6.9,12.6-12.4,25.7-16.4,39.2h-9.9c-16.8,0-30.3,13.4-30.3,30v60c0,16.6,13.6,30,30.3,30h9.8c4.1,13.5,9.5,26.6,16.4,39.2l-7,6.9
c-11.8,11.7-11.8,30.7,0,42.5l42.9,42.5c11.8,11.7,31.1,11.7,42.9,0l7-6.9c12.8,6.8,26,12.2,39.6,16.2v9.8c0,16.6,13.6,30,30.3,30
h60.7c16.8,0,30.3-13.4,30.3-30v-9.7c13.7-4,26.8-9.4,39.6-16.2l7,6.9c11.8,11.7,31.1,11.7,42.9,0l42.9-42.5
c11.8-11.7,11.8-30.7,0-42.5l-7-6.9c6.9-12.6,12.4-25.7,16.4-39.2h9.9c16.8,0,30.3-13.4,30.3-30v-8.2h111.1
c30.2-39.6,77.7-65.5,131.7-65.5c25.7,0,49.8,6.3,71.5,16.6l70.1-69.4c8.3-8.2,12.9-19.3,12.9-30.9V536
C993,511.8,973.2,492.3,948.8,492.3z M352.9,841.6c-60.9,0-110.4-48.9-110.4-109.2c0-60.3,49.4-109.2,110.4-109.2
c60.9,0,110.4,48.9,110.4,109.2C463.3,792.7,413.9,841.6,352.9,841.6z"
      />
      <path
        fill={fill}
        stroke={theme.color.neutral_50}
        strokeMiterlimit={10}
        d="M561.4,624.9c7.5-7.7,11.5-18.1,11.3-28.8c-0.2-10.7-4.6-20.9-12.4-28.4l0,0L463,473.8
c20.3-33.8,29.1-73.6,24.6-113.1c-5.2-45.6-27.5-87.4-62.4-117.1c-34.9-29.7-79.9-44.9-125.7-42.7s-89,21.9-120.8,54.9
c-31.8,33-49.9,76.9-50.5,122.7c-0.6,45.8,16.2,90.2,47.2,124.1c30.9,33.9,73.6,54.6,119.3,58.2c39.7,3.1,79.1-7.1,112.2-28.7
l97.3,93.9c0,0,0,0,0,0c7.7,7.5,18.1,11.5,28.8,11.3C543.7,637,553.9,632.6,561.4,624.9 M380.3,450.1c-18.4,19-43.5,30-70,30.5
c-26.4,0.5-52-9.6-71-27.9c-19-18.4-30-43.5-30.5-70c-0.5-26.4,9.6-52,27.9-71s43.5-30,70-30.5c26.4-0.5,52,9.6,71,27.9
c19,18.4,30,43.5,30.5,70C408.7,405.6,398.6,431.1,380.3,450.1z"
      />
    </svg>
  );
});

export const DataPieIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width, height, fill = theme.color.neutral_200 }) => {
  return (
    <svg
      width={width ? width : 126}
      height={height ? height : 126}
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.4235 16.7462C51.6901 16.1378 55.2001 19.6946 55.2001 24.0002V70.8002H102C106.306 70.8002 109.863 74.3102 109.254 78.5768C107.256 92.2167 100.173 104.596 89.4268 113.232C78.6809 121.867 65.067 126.119 51.3165 125.135C37.5661 124.151 24.6965 118.003 15.2899 107.926C5.88338 97.8478 0.635798 84.5857 0.600098 70.8002C0.600788 57.6657 5.33477 44.9715 13.9344 35.0438C22.5341 25.1162 34.4235 18.6201 47.4235 16.7462ZM118.084 63.0002C121.968 63.0002 125.314 60.1454 125.392 56.261L125.4 55.2002C125.4 47.9405 123.953 40.7537 121.143 34.0601C118.332 27.3665 114.215 21.3006 109.032 16.2173C103.849 11.1339 97.7047 7.13515 90.9579 4.45495C84.2111 1.77475 76.9976 0.466918 69.7393 0.607963C65.8549 0.685963 63.0001 4.03996 63.0001 7.91656V55.2002C63.0001 57.2689 63.8219 59.2528 65.2847 60.7156C66.7475 62.1784 68.7314 63.0002 70.8001 63.0002H118.084Z"
        fill={fill}
      />
    </svg>
  );
});

// 감지내역조회 아이콘
export const DetectListIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 150, height = 150, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 512 512"
        version="1.1"
      >
        <path
          d="M 79.457 71.404 C 72.451 74.456, 47.682 104.544, 35.976 124.223 C 17.108 155.940, 4.981 192.052, 1.055 228.211 C -0.302 240.704, -0.302 271.296, 1.055 283.789 C 5.113 321.164, 18.340 359.513, 38.105 391.209 C 50.306 410.775, 73.118 437.898, 79.678 440.639 C 89.331 444.672, 99.953 439.097, 102.400 428.713 C 103.635 423.472, 101.251 418.294, 93.697 409.808 C 82.358 397.071, 76.233 389.275, 69.024 378.404 C 20.449 305.157, 20.449 206.843, 69.024 133.596 C 76.233 122.725, 82.358 114.929, 93.697 102.192 C 103.516 91.162, 104.851 85.671, 99.771 77.219 C 96.042 71.016, 86.571 68.305, 79.457 71.404 M 417.848 72.018 C 415.839 73.079, 413.309 75.422, 412.226 77.224 C 407.061 85.817, 408.448 91.160, 418.869 102.824 C 440.435 126.962, 454.161 148.678, 464.461 174.954 C 484.164 225.220, 484.164 286.780, 464.461 337.046 C 454.161 363.322, 440.435 385.038, 418.869 409.176 C 410.741 418.273, 408.335 423.345, 409.600 428.713 C 412.047 439.097, 422.669 444.672, 432.322 440.639 C 438.914 437.885, 461.677 410.792, 474.030 391 C 493.959 359.067, 507.239 319.844, 511.067 281.605 C 512.593 266.365, 511.743 231.154, 509.507 217 C 504.291 183.971, 491.299 148.777, 474.074 121.018 C 462.027 101.604, 438.915 74.116, 432.322 71.361 C 427.810 69.476, 422.176 69.731, 417.848 72.018 M 129.500 120.392 C 126.287 121.799, 116.996 131.020, 109.726 140.019 C 92.447 161.405, 78.717 190.871, 73.075 218.675 C 60.988 278.243, 78.892 340.827, 120.342 383.899 C 129.474 393.387, 134.887 395.009, 143.040 390.697 C 147.867 388.145, 152 381.739, 152 376.811 C 152 372.197, 149.261 366.868, 144.132 361.500 C 124.239 340.683, 110.691 314.227, 104.816 284.728 C 101.634 268.748, 101.634 243.252, 104.816 227.272 C 110.691 197.773, 124.239 171.317, 144.132 150.500 C 152.163 142.095, 153.758 135.638, 149.697 127.960 C 145.792 120.576, 136.787 117.201, 129.500 120.392 M 369.138 121.161 C 361.957 124.715, 358.631 132.487, 360.962 140.266 C 361.680 142.665, 364.322 146.633, 367.390 149.920 C 388.319 172.342, 401.251 197.481, 407.184 227.272 C 410.366 243.252, 410.366 268.748, 407.184 284.728 C 401.309 314.227, 387.761 340.683, 367.868 361.500 C 362.739 366.868, 360 372.197, 360 376.811 C 360 381.739, 364.133 388.145, 368.960 390.697 C 377.113 395.009, 382.526 393.387, 391.658 383.899 C 415.161 359.476, 431.906 327.407, 438.860 293.500 C 451.069 233.971, 433.165 171.233, 391.658 128.101 C 382.595 118.684, 377.385 117.079, 369.138 121.161 M 190.500 177.968 C 185.788 179.043, 183.582 180.559, 178.487 186.222 C 168.044 197.831, 159.013 214.558, 154.851 230 C 152.875 237.334, 152.560 240.900, 152.560 256 C 152.560 271.100, 152.875 274.666, 154.851 282 C 159.015 297.450, 168.043 314.168, 178.500 325.792 C 184.347 332.291, 187.937 334.231, 194.119 334.231 C 205.178 334.231, 212.969 322.939, 209.040 312.604 C 208.511 311.215, 205.413 306.902, 202.154 303.021 C 190.193 288.775, 184.833 274.226, 184.833 256 C 184.833 237.774, 190.193 223.225, 202.154 208.979 C 205.413 205.098, 208.511 200.785, 209.040 199.396 C 213.484 187.706, 202.659 175.194, 190.500 177.968 M 314.479 177.969 C 305.164 180.081, 299.572 190.483, 302.960 199.396 C 303.489 200.785, 306.587 205.098, 309.846 208.979 C 321.807 223.225, 327.167 237.774, 327.167 256 C 327.167 274.226, 321.807 288.775, 309.846 303.021 C 306.587 306.902, 303.489 311.215, 302.960 312.604 C 299.031 322.939, 306.822 334.231, 317.881 334.231 C 324.063 334.231, 327.653 332.291, 333.500 325.792 C 343.957 314.168, 352.985 297.450, 357.149 282 C 359.125 274.666, 359.440 271.100, 359.440 256 C 359.440 240.900, 359.125 237.334, 357.149 230 C 352.985 214.550, 343.957 197.832, 333.500 186.208 C 326.853 178.819, 321.313 176.419, 314.479 177.969 M 246.618 217.048 C 240.290 218.638, 231.284 223.968, 226.912 228.711 C 224.667 231.147, 221.405 236.147, 219.665 239.820 C 216.799 245.869, 216.500 247.402, 216.500 256.052 C 216.500 265.067, 216.710 266.028, 220.235 273.160 C 224.733 282.262, 230.523 287.931, 239.820 292.335 C 245.861 295.197, 247.409 295.500, 256 295.500 C 264.591 295.500, 266.139 295.197, 272.180 292.335 C 281.477 287.931, 287.267 282.262, 291.765 273.160 C 295.294 266.020, 295.500 265.075, 295.500 256 C 295.500 246.925, 295.294 245.980, 291.765 238.840 C 285.008 225.167, 273.003 217.144, 258.249 216.442 C 253.987 216.239, 248.753 216.512, 246.618 217.048 M 251 251 C 249.889 252.111, 249 254.333, 249 256 C 249 257.667, 249.889 259.889, 251 261 C 252.111 262.111, 254.333 263, 256 263 C 257.667 263, 259.889 262.111, 261 261 C 262.111 259.889, 263 257.667, 263 256 C 263 254.333, 262.111 252.111, 261 251 C 259.889 249.889, 257.667 249, 256 249 C 254.333 249, 252.111 249.889, 251 251"
          stroke="none"
          fill={fill}
          fillRule="evenodd"
        />
      </svg>
    );
  }
);

// 과거감지내역조회 아이콘
export const DetectPastIcon = ({
  width = 156,
  height = 124,
  fill = theme.color.neutral_200,
}: {
  width?: number;
  height?: number;
  fill?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 31"
      fill="none"
    >
      <g clipPath="url(#clip0_2148_9472)">
        <path
          d="M12.2582 2.94999C9.76663 0.462458 5.77172 0.40687 3.16876 2.72764L2.4867 2.04669C2.26399 1.82435 1.87424 1.93552 1.80464 2.24125L1.01123 5.47921C0.941632 5.77104 1.2061 6.04897 1.51233 5.97949L4.75559 5.18737C5.06182 5.11789 5.17317 4.72878 4.95046 4.50643L4.18489 3.7421C6.23106 1.96331 9.33512 2.0189 11.2699 3.96445C13.3022 5.99339 13.3022 9.28693 11.2699 11.3159C9.22376 13.3309 5.92483 13.3309 3.9065 11.302C3.18268 10.5793 2.6955 9.67604 2.4867 8.67547C2.40318 8.28636 2.02736 8.05012 1.65153 8.1196C1.26178 8.20298 1.02515 8.57819 1.09475 8.95341C1.35922 10.218 1.9856 11.3715 2.90429 12.3025C4.19881 13.5949 5.89699 14.2342 7.58126 14.2342C9.27944 14.2342 10.9776 13.5949 12.2582 12.3025C14.8473 9.71773 14.8473 5.53479 12.2582 2.94999Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.01115 5.47921L1.80457 2.24125C1.87417 1.93552 2.26391 1.82435 2.48663 2.0467L3.16868 2.72764C5.77164 0.406873 9.76655 0.462461 12.2581 2.94999C14.8472 5.5348 14.8472 9.71773 12.2581 12.3025C10.9775 13.5949 9.27936 14.2342 7.58118 14.2342C5.89691 14.2342 4.19873 13.5949 2.90421 12.3025C1.98552 11.3715 1.35914 10.218 1.09467 8.95341C1.02507 8.5782 1.26171 8.20298 1.65145 8.1196C2.02728 8.05012 2.40311 8.28636 2.48663 8.67547C2.69542 9.67604 3.1826 10.5793 3.90642 11.302C5.92475 13.3309 9.22369 13.3309 11.2699 11.3159C13.3021 9.28693 13.3021 5.99339 11.2699 3.96446C9.38298 2.06711 6.38409 1.96723 4.33883 3.61326C4.28686 3.65508 4.23551 3.69803 4.18481 3.74211L4.95039 4.50643C5.1731 4.72878 5.06174 5.11789 4.75551 5.18738L1.51226 5.97949C1.20603 6.04898 0.941556 5.77104 1.01115 5.47921ZM4.8015 5.38202L1.55652 6.17456C1.10452 6.27712 0.712968 5.8674 0.81661 5.43281L0.816897 5.43161L1.60996 2.1951C1.71595 1.73557 2.29564 1.57341 2.62793 1.90516L3.17826 2.45459C5.85993 0.191519 9.87623 0.289349 12.3995 2.80845C15.0666 5.47129 15.0667 9.78082 12.3997 12.4438C11.0793 13.7761 9.3291 14.4342 7.58118 14.4342C5.84654 14.4342 4.09673 13.7757 2.76291 12.4441L2.76184 12.443C1.81685 11.4853 1.17144 10.2975 0.898906 8.99435L0.897974 8.98989C0.809136 8.51095 1.11119 8.03066 1.60961 7.92403L1.61508 7.92286C2.09402 7.83431 2.57524 8.13531 2.68217 8.6335L2.68241 8.63462C2.88328 9.59721 3.35162 10.4655 4.04773 11.1604C5.98725 13.1101 9.16019 13.1122 11.129 11.1739C13.0825 9.22303 13.0824 6.05664 11.1286 4.10599C9.32152 2.28893 6.44903 2.1856 4.48123 3.75544L5.09169 4.3649C5.42466 4.69732 5.26107 5.27639 4.8015 5.38202Z"
          fill={fill}
        />
        <path
          d="M7.63665 3.95058C7.24691 3.95058 6.92676 4.2702 6.92676 4.65931V7.63323C6.92676 8.02234 7.24691 8.34197 7.63665 8.34197H10.1143C10.5041 8.34197 10.8242 8.02234 10.8242 7.63323C10.8242 7.24412 10.5041 6.92449 10.1143 6.92449H8.34655V4.65931C8.34655 4.2702 8.0264 3.95058 7.63665 3.95058Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.72754 4.65932C6.72754 4.15944 7.13754 3.75058 7.63744 3.75058C8.13733 3.75058 8.54733 4.15944 8.54733 4.65932V6.7245H10.1151C10.615 6.7245 11.025 7.13336 11.025 7.63323C11.025 8.13311 10.615 8.54197 10.1151 8.54197H7.63744C7.13754 8.54197 6.72754 8.13311 6.72754 7.63323V4.65932ZM6.92754 4.65932C6.92754 4.27021 7.24769 3.95058 7.63744 3.95058C8.02718 3.95058 8.34733 4.27021 8.34733 4.65932V6.9245H10.1151C10.5049 6.9245 10.825 7.24412 10.825 7.63323C10.825 8.02234 10.5049 8.34197 10.1151 8.34197H7.63744C7.24769 8.34197 6.92754 8.02234 6.92754 7.63323V4.65932Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6285 11.1691C13.3046 13.7602 10.6095 15.5342 7.50001 15.5342C5.86173 15.5342 4.33847 15.0418 3.07018 14.1968L2.46875 14.7903C1.99899 15.2539 1.99899 16.0057 2.46875 16.4693L2.74547 16.7423C2.47258 17.2421 2.25547 17.758 2.09414 18.2923H1.70313C1.03867 18.2923 0.5 18.8239 0.5 19.4796V21.8542C0.5 22.5099 1.03867 23.0415 1.70313 23.0415H2.0936C2.25547 23.5763 2.47203 24.0917 2.74493 24.592L2.46821 24.8651C1.99844 25.3286 1.99844 26.0804 2.46821 26.544L4.16954 28.2229C4.6393 28.6865 5.4011 28.6865 5.87087 28.2229L6.14759 27.9499C6.654 28.2192 7.17681 28.4334 7.71822 28.5926V28.9785C7.71822 29.6342 8.25689 30.1658 8.92134 30.1658H11.3276C11.9921 30.1658 12.5307 29.6342 12.5307 28.9785V28.5932C13.0721 28.434 13.5949 28.2197 14.1014 27.9504L14.3781 28.2235C14.8478 28.6871 15.6096 28.6871 16.0794 28.2235L17.7807 26.5445C18.2505 26.081 18.2505 25.3292 17.7807 24.8656L17.504 24.5925C17.7769 24.0928 17.994 23.5768 18.1553 23.0426H18.5469C19.2114 23.0426 19.75 22.511 19.75 21.8553V21.5315H24.1546C25.3528 19.9669 27.2346 18.941 29.375 18.941C30.3944 18.941 31.3476 19.1898 32.2079 19.5994L34.9871 16.8568C35.3152 16.5329 35.4995 16.0936 35.4995 15.6355V12.896C35.5001 11.9424 34.7164 11.1691 33.7501 11.1691H30.2501V8.99956C30.2501 8.23753 30.5071 7.50141 30.9692 6.90344C31.2109 6.59043 31.1633 6.14465 30.897 5.85161L29.7141 4.5472C29.3499 4.14514 28.7122 4.17374 28.3633 4.5893C27.3286 5.82084 26.75 7.38106 26.75 8.99956V11.1691H21.1539L18.0864 4.10682C17.8849 3.63991 17.5487 3.24183 17.1195 2.96218C16.6904 2.68254 16.1873 2.5337 15.6731 2.5342H13.7454C14.7103 3.73783 15.3344 5.22638 15.4715 6.85357L17.346 11.1691H14.6285ZM24.5625 25.4166C24.5625 22.7938 26.7172 20.6674 29.375 20.6674C32.0329 20.6674 34.1876 22.7938 34.1876 25.4166C34.1876 28.0395 32.0329 30.1658 29.375 30.1658C26.7172 30.1658 24.5625 28.0395 24.5625 25.4166ZM28.0625 25.4166C28.0625 26.1306 28.6515 26.7118 29.375 26.7118C30.0986 26.7118 30.6876 26.1306 30.6876 25.4166C30.6876 24.7026 30.0986 24.1214 29.375 24.1214C28.6515 24.1214 28.0625 24.7026 28.0625 25.4166ZM5.75001 20.6674C5.75001 23.0517 7.70892 24.9849 10.125 24.9849C12.5411 24.9849 14.5 23.0517 14.5 20.6674C14.5 18.2831 12.5411 16.35 10.125 16.35C7.70892 16.35 5.75001 18.2831 5.75001 20.6674Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2148_9472">
          <rect
            width="34.9995"
            height="29.3316"
            fill="white"
            transform="translate(0.5 0.834206)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// 공지사항 아이콘
export const NoticeIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 150, height = 150, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 512 512"
        version="1.1"
      >
        <path
          d="M 323.520 36.598 C 321.331 37.399, 306.931 44.326, 291.520 51.991 C 262.199 66.574, 219.384 90.017, 183.091 111.362 C 159.271 125.372, 158.576 126.025, 151.183 141.341 C 141.473 161.458, 137.855 178.618, 135.395 216.233 C 134.717 226.583, 132.505 230.815, 126.785 232.701 C 119.830 234.994, 112.887 231.009, 110.886 223.575 C 108.059 213.077, 113.315 172.925, 120.467 150.388 C 122.281 144.675, 123.622 140, 123.447 140 C 123.273 140, 119.857 140.689, 115.856 141.530 C 111.855 142.372, 100.238 143.491, 90.040 144.018 C 64.696 145.326, 60.734 145.791, 52.400 148.438 C 29.704 155.645, 10.843 174.506, 3.338 197.500 C -0.430 209.044, -1.042 225.443, 1.867 236.946 C 8.514 263.230, 29.312 284.759, 55.016 291.960 C 60.594 293.523, 67.595 294.305, 82.500 295.032 C 106.449 296.199, 119.078 298.084, 132.585 302.506 C 145.768 306.823, 151.732 309.891, 187.413 330.718 C 203.865 340.321, 227.490 353.792, 239.913 360.655 C 263.733 373.813, 319.812 401.937, 326.356 404.006 C 335.844 407.006, 349.710 402.627, 359.934 393.403 C 398.243 358.836, 419.874 259.002, 408.445 169.500 C 402.735 124.786, 389.042 83.639, 371.875 59.613 C 365.957 51.330, 355.691 41.987, 348.616 38.446 C 342.626 35.448, 340.807 35.009, 334.616 35.070 C 330.702 35.109, 325.709 35.796, 323.520 36.598 M 332.213 79.850 C 317.162 98.891, 306.101 137.594, 301.914 185.870 C 300.416 203.145, 301.296 254.405, 303.350 269.500 C 307.954 303.330, 313.720 325.218, 323.161 344.700 C 325.959 350.472, 330.096 357.115, 332.692 360.003 L 337.280 365.106 340.174 362.334 C 346.898 355.892, 357.011 334.530, 362.376 315.435 C 379.704 253.767, 378.893 175.828, 360.315 117.500 C 354.377 98.859, 341.577 75, 337.514 75 C 336.707 75, 334.321 77.183, 332.213 79.850 M 474 98.949 C 468.313 100.717, 430.395 117.294, 427.784 119.154 C 421.881 123.357, 419.116 134.005, 421.981 141.500 C 423.401 145.216, 427.541 149.678, 431.474 151.731 C 437.963 155.118, 442.866 154.041, 466.500 144.042 C 478.600 138.922, 489.748 133.855, 491.273 132.782 C 495.350 129.914, 498.370 123.411, 498.370 117.500 C 498.370 104.545, 486.083 95.192, 474 98.949 M 315.617 183.255 C 312.757 185.400, 312.119 192.013, 312.119 219.500 C 312.119 258.302, 312.225 258.556, 328 257.752 C 339.004 257.191, 346.201 254.523, 352.805 248.558 C 369.495 233.479, 370.182 208.550, 354.343 192.712 C 346.781 185.150, 340.566 182.675, 328 182.221 C 320.040 181.934, 317.044 182.184, 315.617 183.255 M 442.500 200.659 C 428.004 208.287, 427.300 227.778, 441.251 235.230 C 445.253 237.368, 446.834 237.519, 468.446 237.819 C 493.387 238.167, 498.280 237.541, 503.859 233.291 C 509.872 228.711, 512.676 218.575, 509.939 211.315 C 508.499 207.497, 503.204 202.063, 499.282 200.381 C 494.294 198.241, 446.652 198.474, 442.500 200.659 M 433.843 282.931 C 423.336 286.278, 417.252 296.793, 419.973 306.901 C 422.166 315.043, 424.954 316.945, 450.785 327.912 C 463.828 333.450, 475.880 338.250, 477.566 338.578 C 484.985 340.025, 495.644 333.638, 498.068 326.293 C 500.762 318.132, 498.171 308.721, 491.970 304.136 C 487.999 301.200, 444.562 283.089, 440.182 282.543 C 438.157 282.291, 435.304 282.465, 433.843 282.931 M 73 312.327 C 72.036 313.295, 73.850 357.644, 75.420 371.500 C 78.124 395.349, 84.485 429.237, 89.404 446 C 92.979 458.184, 101.386 468.587, 111.782 473.692 C 116.830 476.171, 118.613 476.500, 127 476.500 C 134.928 476.500, 137.283 476.114, 141.231 474.170 C 149.062 470.313, 155.546 463.698, 159.667 455.360 C 165.165 444.235, 165.363 436.346, 160.643 416.500 C 154.314 389.894, 150.834 366.388, 149.406 340.614 L 148.693 327.728 141.495 324.402 C 131.122 319.610, 119.837 316.129, 109.509 314.537 C 99.946 313.063, 73.842 311.483, 73 312.327"
          stroke="none"
          fill={fill}
          fillRule="evenodd"
        />
      </svg>
    );
  }
);

// 사용자 계정 관리 아이콘
export const RealAdminIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 150, height = 150, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        fill={fill}
        width={width}
        height={height}
        viewBox="0 0 36 36"
        version="1.1"
        preserveAspectRatio="xMidYMid meet"
      >
        <title>administrator-solid</title>
        <circle fill={fill} cx="14.67" cy="8.3" r="6"></circle>
        <path d="M16.44,31.82a2.15,2.15,0,0,1-.38-2.55l.53-1-1.09-.33A2.14,2.14,0,0,1,14,25.84V23.79a2.16,2.16,0,0,1,1.53-2.07l1.09-.33-.52-1a2.17,2.17,0,0,1,.35-2.52,18.92,18.92,0,0,0-2.32-.16A15.58,15.58,0,0,0,2,23.07v7.75a1,1,0,0,0,1,1H16.44Z"></path>
        <path d="M33.7,23.46l-2-.6a6.73,6.73,0,0,0-.58-1.42l1-1.86a.35.35,0,0,0-.07-.43l-1.45-1.46a.38.38,0,0,0-.43-.07l-1.85,1a7.74,7.74,0,0,0-1.43-.6l-.61-2a.38.38,0,0,0-.36-.25H23.84a.38.38,0,0,0-.35.26l-.6,2a6.85,6.85,0,0,0-1.45.61l-1.81-1a.38.38,0,0,0-.44.06l-1.47,1.44a.37.37,0,0,0-.07.44l1,1.82A7.24,7.24,0,0,0,18,22.83l-2,.61a.36.36,0,0,0-.26.35v2.05a.36.36,0,0,0,.26.35l2,.61a7.29,7.29,0,0,0,.6,1.41l-1,1.9a.37.37,0,0,0,.07.44L19.16,32a.38.38,0,0,0,.44.06l1.87-1a7.09,7.09,0,0,0,1.4.57l.6,2.05a.38.38,0,0,0,.36.26h2.05a.38.38,0,0,0,.35-.26l.6-2.05a6.68,6.68,0,0,0,1.38-.57l1.89,1a.38.38,0,0,0,.44-.06L32,30.55a.38.38,0,0,0,.06-.44l-1-1.88a6.92,6.92,0,0,0,.57-1.38l2-.61a.39.39,0,0,0,.27-.35V23.82A.4.4,0,0,0,33.7,23.46Zm-8.83,4.72a3.34,3.34,0,1,1,3.33-3.34A3.34,3.34,0,0,1,24.87,28.18Z"></path>
        <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
      </svg>
    );
  }
);

// 추가 알림 수신자 관리 아이콘
export const NokIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 150, height = 150, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={fill}
          d="M9.5 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
        ></path>
        <path
          fill={fill}
          d="M14.27 4h-2.54c0 0 0 0 0 0-0.955 0-1.73 0.775-1.73 1.73v3.27c0 0.552 0.448 1 1 1v6h4v-6c0.552 0 1-0.448 1-1v-3.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"
        ></path>
        <path
          fill={fill}
          d="M15 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
        ></path>
        <path
          fill={fill}
          d="M4.27 5h-2.54c-0.955 0-1.73 0.775-1.73 1.73s0.775 1.73 1.73 1.73c0.955 0 1.73-0.775 1.73-1.73s-0.775-1.73-1.73-1.73c-0.955 0-1.73 0.775-1.73 1.73v2.27c0 0.552 0.448 1 1 1l-1 3h1v3h4v-3h1l-1-3c0.552 0 1-0.448 1-1v-2.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"
        ></path>
        <path
          fill={fill}
          d="M5 3c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
        ></path>
        <path
          fill={fill}
          d="M7 13v3h2v-3c0.552 0 1-0.448 1-1v-1.54c0-0.806-0.654-1.46-1.46-1.46 0 0 0 0 0 0h-1.080c-0.806 0-1.46 0.654-1.46 1.46 0 0 0 0 0 0v1.54c0 0.552 0.448 1 1 1z"
        ></path>
      </svg>
    );
  }
);

export const GlassIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9527 14.4795L13.0226 11.4703C14.1027 10.0418 14.6121 8.24422 14.4471 6.44356C14.2821 4.64289 13.4551 2.9745 12.1344 1.77803C10.8137 0.581566 9.0987 -0.0530173 7.33847 0.00347202C5.57824 0.0599614 3.90514 0.803277 2.65979 2.08209C1.41443 3.3609 0.690455 5.07907 0.635242 6.88681C0.58003 8.69454 1.19773 10.4559 2.3626 11.8124C3.52747 13.1688 5.15192 14.0184 6.90524 14.1881C8.65857 14.3577 10.4089 13.8348 11.8 12.7257L14.7302 15.7349C14.8103 15.8184 14.9056 15.8848 15.0107 15.9303C15.1159 15.9758 15.2288 15.9995 15.3429 16C15.457 16.0005 15.5701 15.9777 15.6756 15.9331C15.7811 15.8885 15.8769 15.8229 15.9576 15.74C16.0383 15.6571 16.1022 15.5587 16.1457 15.4503C16.1891 15.342 16.2112 15.2259 16.2108 15.1087C16.2103 14.9915 16.1873 14.8756 16.143 14.7676C16.0986 14.6596 16.034 14.5617 15.9527 14.4795ZM2.37608 7.11768C2.37608 6.06424 2.68025 5.03445 3.25013 4.15855C3.82001 3.28265 4.63 2.59996 5.57768 2.19683C6.52535 1.7937 7.56814 1.68822 8.57419 1.89373C9.58023 2.09925 10.5043 2.60653 11.2297 3.35142C11.955 4.09632 12.4489 5.04537 12.649 6.07857C12.8492 7.11177 12.7465 8.1827 12.3539 9.15596C11.9614 10.1292 11.2966 10.9611 10.4437 11.5463C9.59086 12.1316 8.58815 12.444 7.56239 12.444C6.18737 12.4424 4.86911 11.8807 3.89682 10.8822C2.92454 9.88365 2.37763 8.52981 2.37608 7.11768Z"
        fill={theme.color.neutral_400}
      />
    </svg>
  );
});

export const ClipboardBulletIcon: React.FC<{
  width?: number;
  height?: number;
}> = memo(({ width = 44, height = 44 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_656_9173)">
        <path
          d="M15.5878 6.60002H12.1008C11.2256 6.60002 10.3862 6.9477 9.76733 7.56657C9.14846 8.18544 8.80078 9.02481 8.80078 9.90003V36.3C8.80078 37.1752 9.14846 38.0146 9.76733 38.6335C10.3862 39.2523 11.2256 39.6 12.1008 39.6H31.9008C32.776 39.6 33.6154 39.2523 34.2342 38.6335C34.8531 38.0146 35.2008 37.1752 35.2008 36.3V9.90003C35.2008 9.02481 34.8531 8.18544 34.2342 7.56657C33.6154 6.9477 32.776 6.60002 31.9008 6.60002H28.4138C28.1862 5.95635 27.7646 5.39911 27.2071 5.00509C26.6495 4.61107 25.9835 4.39967 25.3008 4.40002H18.7008C18.0181 4.39967 17.352 4.61107 16.7945 5.00509C16.237 5.39911 15.8154 5.95635 15.5878 6.60002ZM18.7008 6.60002H25.3008C25.5925 6.60002 25.8723 6.71592 26.0786 6.92221C26.2849 7.1285 26.4008 7.40829 26.4008 7.70003C26.4008 7.99176 26.2849 8.27155 26.0786 8.47784C25.8723 8.68413 25.5925 8.80002 25.3008 8.80002H18.7008C18.409 8.80002 18.1293 8.68413 17.923 8.47784C17.7167 8.27155 17.6008 7.99176 17.6008 7.70003C17.6008 7.40829 17.7167 7.1285 17.923 6.92221C18.1293 6.71592 18.409 6.60002 18.7008 6.60002ZM19.8008 18.7C19.8008 18.4083 19.9167 18.1285 20.123 17.9222C20.3293 17.7159 20.609 17.6 20.9008 17.6H28.6008C28.8925 17.6 29.1723 17.7159 29.3786 17.9222C29.5849 18.1285 29.7008 18.4083 29.7008 18.7C29.7008 18.9918 29.5849 19.2716 29.3786 19.4778C29.1723 19.6841 28.8925 19.8 28.6008 19.8H20.9008C20.609 19.8 20.3293 19.6841 20.123 19.4778C19.9167 19.2716 19.8008 18.9918 19.8008 18.7ZM19.8008 25.3C19.8008 25.0083 19.9167 24.7285 20.123 24.5222C20.3293 24.3159 20.609 24.2 20.9008 24.2H28.6008C28.8925 24.2 29.1723 24.3159 29.3786 24.5222C29.5849 24.7285 29.7008 25.0083 29.7008 25.3C29.7008 25.5918 29.5849 25.8716 29.3786 26.0778C29.1723 26.2841 28.8925 26.4 28.6008 26.4H20.9008C20.609 26.4 20.3293 26.2841 20.123 26.0778C19.9167 25.8716 19.8008 25.5918 19.8008 25.3ZM19.8008 31.9C19.8008 31.6083 19.9167 31.3285 20.123 31.1222C20.3293 30.9159 20.609 30.8 20.9008 30.8H28.6008C28.8925 30.8 29.1723 30.9159 29.3786 31.1222C29.5849 31.3285 29.7008 31.6083 29.7008 31.9C29.7008 32.1918 29.5849 32.4716 29.3786 32.6778C29.1723 32.8841 28.8925 33 28.6008 33H20.9008C20.609 33 20.3293 32.8841 20.123 32.6778C19.9167 32.4716 19.8008 32.1918 19.8008 31.9ZM17.6008 18.7C17.6008 19.1376 17.4269 19.5573 17.1175 19.8667C16.8081 20.1762 16.3884 20.35 15.9508 20.35C15.5132 20.35 15.0935 20.1762 14.7841 19.8667C14.4746 19.5573 14.3008 19.1376 14.3008 18.7C14.3008 18.2624 14.4746 17.8427 14.7841 17.5333C15.0935 17.2239 15.5132 17.05 15.9508 17.05C16.3884 17.05 16.8081 17.2239 17.1175 17.5333C17.4269 17.8427 17.6008 18.2624 17.6008 18.7ZM17.6008 25.3C17.6008 25.7376 17.4269 26.1573 17.1175 26.4668C16.8081 26.7762 16.3884 26.95 15.9508 26.95C15.5132 26.95 15.0935 26.7762 14.7841 26.4668C14.4746 26.1573 14.3008 25.7376 14.3008 25.3C14.3008 24.8624 14.4746 24.4427 14.7841 24.1333C15.0935 23.8239 15.5132 23.65 15.9508 23.65C16.3884 23.65 16.8081 23.8239 17.1175 24.1333C17.4269 24.4427 17.6008 24.8624 17.6008 25.3ZM15.9508 33.55C15.5132 33.55 15.0935 33.3762 14.7841 33.0668C14.4746 32.7573 14.3008 32.3376 14.3008 31.9C14.3008 31.4624 14.4746 31.0427 14.7841 30.7333C15.0935 30.4239 15.5132 30.25 15.9508 30.25C16.3884 30.25 16.8081 30.4239 17.1175 30.7333C17.4269 31.0427 17.6008 31.4624 17.6008 31.9C17.6008 32.3376 17.4269 32.7573 17.1175 33.0668C16.8081 33.3762 16.3884 33.55 15.9508 33.55Z"
          fill={theme.color.neutral_500}
        />
        <path
          d="M24.7627 19.7627L24.7623 19.763C24.5387 19.9869 24.3799 20.2671 24.3027 20.574L24.2979 20.5931L24.2941 20.6124L23.4076 25.1249C23.2363 25.9966 24.0035 26.7637 24.8751 26.5924L24.7305 25.8565L24.8751 26.5924L29.3866 25.7059L29.4054 25.7022L29.4239 25.6976C29.7312 25.6208 30.0128 25.4618 30.2373 25.2373L39.1768 16.2979C39.6649 15.8097 39.6649 15.0183 39.1768 14.5301L35.4699 10.8232C34.9817 10.3351 34.1903 10.3351 33.7021 10.8232L24.7627 19.7627ZM42.5303 12.9443L42.5304 12.9443C43.046 12.4286 43.3356 11.7292 43.3356 11C43.3356 10.2708 43.046 9.57145 42.5304 9.05575L42.5303 9.05567L40.9443 7.46967L40.9443 7.46959C40.4285 6.95405 39.7292 6.66443 39 6.66443C38.2708 6.66443 37.5715 6.95405 37.0558 7.46959L37.0557 7.46967L35.8232 8.70212C35.3351 9.19027 35.3351 9.98173 35.8232 10.4699L39.5301 14.1768C40.0183 14.6649 40.8097 14.6649 41.2979 14.1768L40.7676 13.6464L41.2979 14.1768L42.5303 12.9443Z"
          fill={theme.color.neutral_500}
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_656_9173">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const GraySmallCalendarIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 11.9C0 13.09 0.91 14 2.1 14H11.9C13.09 14 14 13.09 14 11.9V6.3H0V11.9ZM11.9 1.4H10.5V0.7C10.5 0.28 10.22 0 9.8 0C9.38 0 9.1 0.28 9.1 0.7V1.4H4.9V0.7C4.9 0.28 4.62 0 4.2 0C3.78 0 3.5 0.28 3.5 0.7V1.4H2.1C0.91 1.4 0 2.31 0 3.5V4.9H14V3.5C14 2.31 13.09 1.4 11.9 1.4Z"
        fill={theme.color.neutral_300}
      />
    </svg>
  );
});

export const GrayUserIcon: React.FC<{
  width?: number;
  height?: number;
}> = memo((props) => {
  const { width, height } = props;
  return (
    <svg
      width={width ? width : 12}
      height={height ? height : 12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12C1 12 0 12 0 11C0 10 1 7 6 7C11 7 12 10 12 11C12 12 11 12 11 12H1ZM6 6C6.79565 6 7.55871 5.68393 8.12132 5.12132C8.68393 4.55871 9 3.79565 9 3C9 2.20435 8.68393 1.44129 8.12132 0.87868C7.55871 0.316071 6.79565 0 6 0C5.20435 0 4.44129 0.316071 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3C3 3.79565 3.31607 4.55871 3.87868 5.12132C4.44129 5.68393 5.20435 6 6 6Z"
        fill={theme.color.neutral_400}
      />
    </svg>
  );
});

//로그아웃 아이콘
export const LogOutIcon: React.FC<{ width?: number; height?: number }> =
  memo((props) => {
    const { width, height } = props;
    return (
      <svg
        width={width ? width : 12}
        height={height ? height : 12}
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          width={width ? width : 12}
          height={height ? height : 12}
          d="M8.66667 10.333V8.33301H4V5.66634H8.66667V3.66634L12 6.99967L8.66667 10.333ZM7.33333 0.333008C7.68696 0.333008 8.02609 0.473484 8.27614 0.723532C8.52619 0.97358 8.66667 1.31272 8.66667 1.66634V2.99967H7.33333V1.66634H1.33333V12.333H7.33333V10.9997H8.66667V12.333C8.66667 12.6866 8.52619 13.0258 8.27614 13.2758C8.02609 13.5259 7.68696 13.6663 7.33333 13.6663H1.33333C0.979711 13.6663 0.640573 13.5259 0.390524 13.2758C0.140476 13.0258 0 12.6866 0 12.333V1.66634C0 1.31272 0.140476 0.97358 0.390524 0.723532C0.640573 0.473484 0.979711 0.333008 1.33333 0.333008H7.33333Z"
          fill={theme.color.neutral_300}
        />
      </svg>
    );
  });

export const WarningIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2027 2.78869C19.8671 2.08991 19.341 1.50015 18.6848 1.08736C18.0287 0.674576 17.2693 0.455566 16.4941 0.455566C15.7189 0.455566 14.9595 0.674576 14.3034 1.08736C13.6473 1.50015 13.1211 2.08991 12.7856 2.78869L0.949747 26.071C-0.466295 28.8506 1.32308 32.5416 4.65683 32.5416H28.33C31.6652 32.5416 33.4516 28.852 32.0385 26.071L20.2027 2.78869ZM16.4941 10.6666C16.8809 10.6666 17.2518 10.8203 17.5253 11.0937C17.7988 11.3672 17.9525 11.7382 17.9525 12.1249V19.4166C17.9525 19.8034 17.7988 20.1743 17.5253 20.4478C17.2518 20.7213 16.8809 20.8749 16.4941 20.8749C16.1073 20.8749 15.7364 20.7213 15.4629 20.4478C15.1894 20.1743 15.0358 19.8034 15.0358 19.4166V12.1249C15.0358 11.7382 15.1894 11.3672 15.4629 11.0937C15.7364 10.8203 16.1073 10.6666 16.4941 10.6666ZM16.4941 23.0624C16.8809 23.0624 17.2518 23.2161 17.5253 23.4896C17.7988 23.7631 17.9525 24.134 17.9525 24.5208V25.2499C17.9525 25.6367 17.7988 26.0076 17.5253 26.2811C17.2518 26.5546 16.8809 26.7083 16.4941 26.7083C16.1073 26.7083 15.7364 26.5546 15.4629 26.2811C15.1894 26.0076 15.0358 25.6367 15.0358 25.2499V24.5208C15.0358 24.134 15.1894 23.7631 15.4629 23.4896C15.7364 23.2161 16.1073 23.0624 16.4941 23.0624Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const GrayClassAndBoardIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 8.875V3.25H1.25V5.101C1.8792 4.78856 2.59022 4.68024 3.28392 4.79116C3.97762 4.90207 4.61941 5.22669 5.11982 5.71975C5.62023 6.21281 5.95431 6.84974 6.07548 7.54172C6.19664 8.2337 6.09885 8.94624 5.79575 9.58L6.96575 10.75H9.875C10.3723 10.75 10.8492 10.5525 11.2008 10.2008C11.5525 9.84919 11.75 9.37228 11.75 8.875ZM11.75 2.125C11.75 1.62772 11.5525 1.15081 11.2008 0.799175C10.8492 0.447544 10.3723 0.25 9.875 0.25H3.125C2.62772 0.25 2.15081 0.447544 1.79917 0.799175C1.44754 1.15081 1.25 1.62772 1.25 2.125V2.5H11.75V2.125ZM4.322 10.2273C3.79051 10.6247 3.1282 10.8061 2.46837 10.7349C1.80855 10.6636 1.20018 10.3452 0.765707 9.84349C0.331236 9.34182 0.102912 8.6942 0.126686 8.03096C0.150461 7.36773 0.42457 6.73812 0.893846 6.26885C1.36312 5.79957 1.99273 5.52546 2.65596 5.50169C3.3192 5.47791 3.96682 5.70624 4.46849 6.14071C4.97016 6.57518 5.28865 7.18355 5.35985 7.84337C5.43105 8.5032 5.24969 9.16551 4.85225 9.697L6.76475 11.6095C6.83516 11.6798 6.87476 11.7752 6.87483 11.8747C6.8749 11.9742 6.83544 12.0697 6.76513 12.1401C6.69481 12.2105 6.5994 12.2501 6.49989 12.2502C6.40038 12.2503 6.30491 12.2108 6.2345 12.1405L4.322 10.228V10.2273ZM4.625 8.125C4.625 7.62772 4.42746 7.15081 4.07583 6.79917C3.72419 6.44754 3.24728 6.25 2.75 6.25C2.25272 6.25 1.77581 6.44754 1.42417 6.79917C1.07254 7.15081 0.875 7.62772 0.875 8.125C0.875 8.62228 1.07254 9.09919 1.42417 9.45082C1.77581 9.80246 2.25272 10 2.75 10C3.24728 10 3.72419 9.80246 4.07583 9.45082C4.42746 9.09919 4.625 8.62228 4.625 8.125Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

// 사용자 계정 관리 - 정보 상세보기 아이콘
export const DetailUserIcon: React.FC<{}> = memo(() => {
  return (
    <svg width="15" height="15" viewBox="0 0 512 512" version="1.1">
      <path
        d="M 199.500 0.703 C 182.840 2.233, 157.366 8.492, 140.500 15.201 C 64.654 45.369, 12.384 112.581, 1.449 194 C -0.207 206.331, -0.436 234.944, 1.024 247.026 C 10.467 325.142, 59.631 392.547, 130.259 424.211 C 197.428 454.324, 273.095 449.977, 336.009 412.390 L 350.305 403.849 401.903 455.265 C 461.166 514.319, 457.466 511.454, 474.500 511.483 C 483.260 511.498, 485.204 511.170, 490.175 508.840 C 498.121 505.115, 504.397 498.970, 508.250 491.144 C 511.261 485.027, 511.500 483.806, 511.500 474.521 C 511.500 457.516, 514.353 461.200, 455.251 401.889 L 403.823 350.279 410.993 338.389 C 427.257 311.420, 436.897 285.204, 441.690 254.904 C 444.447 237.472, 444.169 202.859, 441.133 185.690 C 423.783 87.551, 347.575 14.240, 249.699 1.532 C 238.930 0.134, 210.766 -0.331, 199.500 0.703 M 202.500 71.065 C 169.281 75.551, 138.431 90.901, 114.683 114.761 C 93.064 136.481, 79.316 161.969, 72.830 192.352 C 69.910 206.029, 69.647 234.970, 72.319 248.500 C 78.975 282.203, 93.916 309.613, 117.977 332.262 C 170.876 382.059, 250.882 387.488, 310.291 345.312 C 320.789 337.859, 337.859 320.789, 345.312 310.291 C 378.044 264.185, 382.733 204.164, 357.521 154 C 336.257 111.690, 296.670 81.682, 250 72.497 C 239.933 70.516, 212.657 69.694, 202.500 71.065 M 207 102.016 C 154.856 109.271, 114.729 146.642, 103.404 198.500 C 100.828 210.298, 101.008 234.501, 103.763 246.500 C 115.047 295.658, 151.551 331.214, 200.273 340.500 C 208.595 342.086, 230.444 342.672, 237.658 341.502 C 265.531 336.984, 288.551 325.556, 307.054 307.054 C 325.556 288.551, 336.984 265.531, 341.502 237.658 C 341.845 235.545, 342.115 228.056, 342.103 221.015 C 342.007 164.383, 303.039 116.407, 247 103.927 C 237.061 101.714, 216.302 100.722, 207 102.016 M 206 119.174 C 195.965 120.606, 178.676 126.786, 169.824 132.106 C 144.607 147.261, 128.782 168.469, 120.793 197.813 C 119.085 204.088, 118.695 208.440, 118.673 221.500 C 118.649 235.755, 118.938 238.590, 121.327 247.491 C 124.316 258.634, 129.064 269.339, 135.217 278.813 L 139.317 285.126 142.932 278.255 C 148.085 268.462, 152.936 262.205, 161.871 253.827 C 196.275 221.567, 249.119 222.264, 283.850 255.435 C 290.386 261.678, 299.578 274.530, 302.405 281.380 L 304.007 285.261 305.825 282.880 C 309.215 278.443, 314.788 268.527, 317.385 262.316 C 333.999 222.571, 324.882 177.487, 294.235 147.833 C 270.366 124.738, 238.821 114.492, 206 119.174 M 214.176 141.014 C 201.846 143.601, 191.207 152.100, 185.706 163.759 C 182.872 169.766, 182.524 171.480, 182.513 179.500 C 182.493 193.721, 187.403 203.764, 198.524 212.249 C 217.162 226.468, 246.392 219.734, 257.124 198.749 C 268.158 177.171, 257.711 150.411, 235.184 142.549 C 229.579 140.592, 219.645 139.867, 214.176 141.014"
        stroke="none"
        fill={theme.color.neutral_500}
        fillRule="evenodd"
      />
    </svg>
  );
});

// 사용자 계정 관리 - 연락처 열람 기록 보기 아이콘
export const DetailRecordIcon: React.FC<{}> = memo(() => {
  return (
    <svg width="15" height="15" viewBox="0 0 512 512" version="1.1">
      <path
        d="M 114.512 1.614 C 103.939 4.170, 94.269 9.703, 85.905 17.982 C 77.164 26.634, 72.062 35.116, 69.064 45.980 C 67.285 52.427, 67 56.327, 67 74.230 L 67 95 86.818 95 C 113.085 95, 118.978 96.719, 128.615 107.191 C 136.730 116.009, 139.350 130.643, 134.929 142.459 C 132.032 150.204, 124.691 157.947, 116.791 161.593 C 110.553 164.472, 110.318 164.499, 88.750 164.833 L 67 165.169 67 193.015 L 67 220.860 88.750 221.180 C 110.339 221.498, 110.547 221.522, 116.791 224.405 C 143.740 236.849, 143.740 275.151, 116.791 287.595 C 110.547 290.478, 110.339 290.502, 88.750 290.820 L 67 291.140 67 318.985 L 67 346.831 88.750 347.167 C 110.318 347.501, 110.553 347.528, 116.791 350.407 C 146.017 363.894, 142.877 406.238, 111.972 415.416 C 107.887 416.629, 101.992 417, 86.818 417 L 67 417 67 437.340 C 67 460.798, 68.408 468.631, 74.652 479.899 C 79.907 489.382, 91.556 500.580, 101 505.226 C 115.543 512.381, 105.388 511.969, 267.701 511.985 C 368.869 511.995, 415.534 511.666, 419.201 510.916 C 422.115 510.319, 428.639 507.846, 433.698 505.419 C 449.127 498.017, 460.985 484.217, 466.282 467.500 L 468.500 460.500 468.500 256 L 468.500 51.500 466.282 44.500 C 460.985 27.783, 449.127 13.983, 433.698 6.581 C 428.639 4.154, 422.115 1.681, 419.201 1.084 C 415.524 0.332, 368.985 0.026, 267.201 0.083 C 142.795 0.154, 119.590 0.387, 114.512 1.614 M 53.907 112.327 C 40.432 119.441, 39.367 137.660, 51.910 146.500 L 56.167 149.500 81.333 149.792 C 105.897 150.077, 106.606 150.029, 110.942 147.792 C 113.385 146.531, 116.760 143.771, 118.442 141.657 C 121.264 138.111, 121.500 137.211, 121.500 130 C 121.500 122.789, 121.264 121.889, 118.442 118.343 C 116.760 116.229, 113.402 113.487, 110.980 112.250 C 106.773 110.100, 105.498 110, 82.445 110 C 59.114 110, 58.168 110.077, 53.907 112.327 M 272 127.079 C 248.074 129.795, 226.705 148.993, 220.885 173 C 219.030 180.651, 219.300 195.171, 221.433 202.500 C 230.745 234.494, 262.720 253.128, 294.404 245.025 C 305.777 242.116, 313.376 237.712, 322.109 228.969 C 337.420 213.639, 343.261 193.070, 338.068 172.766 C 330.290 142.353, 303.097 123.549, 272 127.079 M 53.907 238.327 C 51.483 239.606, 48.150 242.570, 46.500 244.913 C 43.875 248.639, 43.500 250.027, 43.500 256 C 43.500 261.973, 43.875 263.361, 46.500 267.087 C 48.150 269.430, 51.483 272.394, 53.907 273.673 C 58.168 275.923, 59.114 276, 82.445 276 C 105.498 276, 106.773 275.900, 110.980 273.750 C 113.402 272.512, 116.760 269.771, 118.442 267.657 C 121.264 264.111, 121.500 263.211, 121.500 256 C 121.500 248.789, 121.264 247.889, 118.442 244.343 C 116.760 242.229, 113.402 239.488, 110.980 238.250 C 106.773 236.100, 105.498 236, 82.445 236 C 59.114 236, 58.168 236.077, 53.907 238.327 M 240.486 269.412 C 219.492 273.356, 201.894 286.893, 192.611 306.240 C 186.864 318.219, 185.973 322.835, 185.277 344.250 L 184.700 362 279.350 362 L 374 362 373.965 346.750 C 373.913 323.792, 371.132 311.703, 363.016 299.145 C 354.643 286.191, 341.779 276.375, 326.500 271.282 C 318.508 268.618, 318.466 268.615, 283 268.355 C 256.886 268.164, 245.646 268.443, 240.486 269.412 M 56.685 363.017 C 52.073 364.401, 47.349 368.647, 44.984 373.534 C 40.384 383.036, 44.339 394.622, 53.907 399.673 C 58.168 401.923, 59.114 402, 82.445 402 C 105.498 402, 106.773 401.900, 110.980 399.750 C 113.402 398.512, 116.760 395.771, 118.442 393.657 C 121.264 390.111, 121.500 389.211, 121.500 382 C 121.500 374.789, 121.264 373.889, 118.442 370.343 C 116.760 368.229, 113.402 365.488, 110.980 364.250 C 106.765 362.097, 105.565 362.004, 83.038 362.086 C 70.092 362.133, 58.233 362.552, 56.685 363.017"
        stroke="none"
        fill={theme.color.neutral_500}
        fillRule="evenodd"
      />
    </svg>
  );
});

export const GrayMapIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.39583V9.58333L3.35417 7.4865V0.299L0 2.39583ZM7.1875 9.28433V2.09683L4.3125 0.299958V7.48746L7.1875 9.28338V9.28433ZM8.14583 9.28433V2.09683L11.5 0V7.1875L8.14583 9.28433Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const CameraIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5884 9.64584C10.9928 9.64584 9.64453 10.9941 9.64453 12.5897C9.64453 14.1853 10.9928 15.5336 12.5884 15.5336C14.184 15.5336 15.5323 14.1853 15.5323 12.5897C15.5323 10.9941 14.184 9.64584 12.5884 9.64584Z"
        fill={theme.color.neutral_400}
      />
      <path
        d="M20.4406 5.72616H17.903L15.2466 3.06981C15.1557 2.97851 15.0475 2.9061 14.9285 2.85675C14.8094 2.80741 14.6817 2.7821 14.5528 2.78229H10.6277C10.4988 2.7821 10.3711 2.80741 10.2521 2.85675C10.133 2.9061 10.0249 2.97851 9.93391 3.06981L7.27755 5.72616H4.73993C3.65756 5.72616 2.77734 6.60638 2.77734 7.68875V18.483C2.77734 19.5653 3.65756 20.4455 4.73993 20.4455H20.4406C21.523 20.4455 22.4032 19.5653 22.4032 18.483V7.68875C22.4032 6.60638 21.523 5.72616 20.4406 5.72616ZM12.5903 17.5017C9.93096 17.5017 7.6838 15.2545 7.6838 12.5952C7.6838 9.93591 9.93096 7.68875 12.5903 7.68875C15.2496 7.68875 17.4967 9.93591 17.4967 12.5952C17.4967 15.2545 15.2496 17.5017 12.5903 17.5017Z"
        fill={theme.color.neutral_400}
      />
    </svg>
  );
});

export const PhoneIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9583 11.6667C20.1187 11.6667 21.2315 12.1276 22.0519 12.9481C22.8724 13.7685 23.3333 14.8813 23.3333 16.0417C23.3333 16.4284 23.487 16.7994 23.7605 17.0729C24.034 17.3464 24.4049 17.5 24.7917 17.5C25.1784 17.5 25.5494 17.3464 25.8229 17.0729C26.0964 16.7994 26.25 16.4284 26.25 16.0417C26.25 14.1078 25.4818 12.2531 24.1143 10.8857C22.7469 9.51823 20.8922 8.75 18.9583 8.75C18.5716 8.75 18.2006 8.90365 17.9271 9.17714C17.6536 9.45063 17.5 9.82156 17.5 10.2083C17.5 10.5951 17.6536 10.966 17.9271 11.2395C18.2006 11.513 18.5716 11.6667 18.9583 11.6667Z"
        fill={theme.color.neutral_500}
      />
      <path
        d="M18.9596 5.83329C21.6671 5.83329 24.2636 6.90881 26.178 8.82324C28.0924 10.7377 29.168 13.3342 29.168 16.0416C29.168 16.4284 29.3216 16.7993 29.5951 17.0728C29.8686 17.3463 30.2395 17.5 30.6263 17.5C31.0131 17.5 31.384 17.3463 31.6575 17.0728C31.931 16.7993 32.0846 16.4284 32.0846 16.0416C32.0846 12.5607 30.7018 9.22226 28.2404 6.76085C25.779 4.29943 22.4406 2.91663 18.9596 2.91663C18.5729 2.91663 18.2019 3.07027 17.9284 3.34376C17.6549 3.61725 17.5013 3.98819 17.5013 4.37496C17.5013 4.76173 17.6549 5.13267 17.9284 5.40616C18.2019 5.67965 18.5729 5.83329 18.9596 5.83329ZM31.7201 23.202C31.6398 22.9679 31.5014 22.7581 31.3177 22.5922C31.134 22.4264 30.9111 22.3101 30.6701 22.2541L21.9201 20.2562C21.6825 20.2024 21.4353 20.2088 21.201 20.2751C20.9666 20.3413 20.7526 20.4652 20.5784 20.6354C20.3742 20.825 20.3596 20.8395 19.4117 22.6479C16.2664 21.1985 13.7461 18.6679 12.3096 15.5166C14.1617 14.5833 14.1763 14.5833 14.3659 14.3645C14.5361 14.1904 14.66 13.9763 14.7262 13.742C14.7924 13.5076 14.7989 13.2604 14.7451 13.0229L12.7471 4.37496C12.6912 4.13389 12.5748 3.91102 12.409 3.72733C12.2432 3.54364 12.0333 3.40517 11.7992 3.32496C11.4586 3.20332 11.107 3.1154 10.7492 3.06246C10.3806 2.97699 10.0045 2.92815 9.6263 2.91663C7.84714 2.91663 6.14085 3.62339 4.88279 4.88145C3.62474 6.13951 2.91797 7.8458 2.91797 9.62496C2.92569 15.5789 5.2943 21.2868 9.50439 25.4969C13.7145 29.707 19.4223 32.0756 25.3763 32.0833C26.2573 32.0833 27.1296 31.9098 27.9435 31.5726C28.7574 31.2355 29.4969 30.7414 30.1198 30.1185C30.7427 29.4955 31.2369 28.756 31.574 27.9421C31.9111 27.1282 32.0846 26.2559 32.0846 25.375C32.0851 25.0038 32.0558 24.6331 31.9971 24.2666C31.9358 23.9044 31.8431 23.5482 31.7201 23.202Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const LockIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.18164 10.7027C8.18164 10.7027 8.18168 8.13513 8.18164 6.59459C8.1816 4.74571 9.70861 3 11.9998 3C14.291 3 15.8179 4.74571 15.8179 6.59459C15.8179 8.13513 15.8179 10.7027 15.8179 10.7027"
        stroke={theme.color.neutral_500}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50005 11.3932C4.50001 13.1319 4.49995 16.764 4.50007 19.1988C4.5002 21.8911 8.66375 22.5 12.0001 22.5C15.3364 22.5 19.5 21.8911 19.5 19.1988L19.5 11.3932C19.5 10.8409 19.0523 10.3957 18.5 10.3957H5.50004C4.94777 10.3957 4.50006 10.8409 4.50005 11.3932ZM10.5 16.0028C10.5 16.4788 10.7069 16.9065 11.0357 17.2008V18.7529C11.0357 19.3051 11.4834 19.7529 12.0357 19.7529H12.1786C12.7309 19.7529 13.1786 19.3051 13.1786 18.7529V17.2008C13.5074 16.9065 13.7143 16.4788 13.7143 16.0028C13.7143 15.1152 12.9948 14.3957 12.1072 14.3957C11.2195 14.3957 10.5 15.1152 10.5 16.0028Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const GrayArrowRight: React.FC<{}> = memo(() => {
  return (
    <svg
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.69246 8.3893L1.07881 15.186C1.02436 15.2407 0.981309 15.3058 0.952155 15.3773C0.923 15.4488 0.90832 15.5254 0.90896 15.6026C0.909602 15.6799 0.925554 15.7562 0.955893 15.8272C0.986231 15.8982 1.03035 15.9626 1.08571 16.0164C1.14106 16.0703 1.20655 16.1126 1.27837 16.141C1.3502 16.1694 1.42695 16.1832 1.50417 16.1818C1.58139 16.1803 1.65755 16.1635 1.72824 16.1324C1.79894 16.1013 1.86276 16.0565 1.91603 16.0006L8.92531 8.79662C9.0314 8.68757 9.09076 8.54144 9.09076 8.3893C9.09076 8.23716 9.0314 8.09103 8.92531 7.98198L1.91603 0.777996C1.86276 0.722068 1.79894 0.677259 1.72824 0.64616C1.65755 0.615061 1.58139 0.598293 1.50417 0.596822C1.42695 0.595352 1.3502 0.60921 1.27838 0.637594C1.20655 0.66598 1.14106 0.708328 1.08571 0.762188C1.03035 0.816049 0.986232 0.880352 0.955894 0.951378C0.925556 1.0224 0.909603 1.09874 0.908962 1.17597C0.908321 1.2532 0.923002 1.32979 0.952156 1.40131C0.98131 1.47283 1.02436 1.53786 1.07881 1.59263L7.69323 8.3893L7.69246 8.3893Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const FoldArrowRight: React.FC<{}> = memo(() => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.489 31.975c-0.271 0-0.549-0.107-0.757-0.316-0.417-0.417-0.417-1.098 0-1.515l14.258-14.264-14.050-14.050c-0.417-0.417-0.417-1.098 0-1.515s1.098-0.417 1.515 0l14.807 14.807c0.417 0.417 0.417 1.098 0 1.515l-15.015 15.022c-0.208 0.208-0.486 0.316-0.757 0.316z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const FoldArrowLeft: React.FC<{}> = memo(() => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.505 0c0.271 0 0.549 0.107 0.757 0.316 0.417 0.417 0.417 1.098 0 1.515l-14.258 14.264 14.050 14.050c0.417 0.417 0.417 1.098 0 1.515s-1.098 0.417-1.515 0l-14.807-14.807c-0.417-0.417-0.417-1.098 0-1.515l15.015-15.022c0.208-0.208 0.486-0.316 0.757-0.316z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

//농기계 사용 리포트 아이콘
export const ReportIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1663 5.66675L9.91634 1.41675H4.24967C3.87395 1.41675 3.51362 1.566 3.24794 1.83168C2.98226 2.09736 2.83301 2.45769 2.83301 2.83341V14.1667C2.83301 14.5425 2.98226 14.9028 3.24794 15.1685C3.51362 15.4342 3.87395 15.5834 4.24967 15.5834H12.7497C13.1254 15.5834 13.4857 15.4342 13.7514 15.1685C14.0171 14.9028 14.1663 14.5425 14.1663 14.1667V5.66675ZM6.37467 13.4584H4.95801V7.08341H6.37467V13.4584ZM9.20801 13.4584H7.79134V9.20841H9.20801V13.4584ZM12.0413 13.4584H10.6247V11.3334H12.0413V13.4584ZM9.91634 6.37508H9.20801V2.83341L12.7497 6.37508H9.91634Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const WarningModalIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="38"
      height="40"
      viewBox="0 0 38 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 18.5C11.25 13.9436 14.9437 10.25 19.5 10.25C24.0563 10.25 27.75 13.9437 27.75 18.5V28.4H11.25V18.5Z"
        fill={theme.color.red_500}
      />
      <path
        d="M7.9502 31.9291C7.9502 29.9799 9.53037 28.3997 11.4796 28.3997H27.5208C29.47 28.3997 31.0502 29.9799 31.0502 31.9291V34.9997H7.9502V31.9291Z"
        fill={theme.color.neutral_200}
      />
      <path
        d="M27.75 28.4V18.5C27.75 16.312 26.8808 14.2135 25.3336 12.6664C23.7865 11.1192 21.688 10.25 19.5 10.25C17.312 10.25 15.2135 11.1192 13.6664 12.6664C12.1192 14.2135 11.25 16.312 11.25 18.5V28.4M27.75 28.4C28.6252 28.4 29.4646 28.7477 30.0835 29.3665C30.7023 29.9854 31.05 30.8248 31.05 31.7V35H7.95V31.7C7.95 30.8248 8.29768 29.9854 8.91655 29.3665C9.53542 28.7477 10.3748 28.4 11.25 28.4M27.75 28.4H19.5H11.25M34.35 18.5H36M30.225 6.125L29.4 6.95M3 18.5H4.65M19.5 2V3.65M7.83285 6.83285L8.9994 7.9994"
        stroke={theme.color.neutral_600}
        strokeWidth="2.29412"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.585786"
        y="6"
        width="5.02286"
        height="47.5448"
        rx="2.51143"
        transform="rotate(-45 0.585786 6)"
        fill={theme.color.neutral_600}
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
});

export const TrashCanIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      stroke={theme.color.neutral_500}
      fill={theme.color.neutral_500}
      strokeWidth="0"
      viewBox="0 0 448 512"
      height="15"
      width="15"
    >
      <path d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path>
    </svg>
  );
});

export const MiniTractorIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="45"
      height="35"
      viewBox="0 0 45 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.9734 22.9688C33.6069 22.9688 30.8776 25.6621 30.8776 28.9844C30.8776 32.3066 33.6069 35 36.9734 35C40.34 35 43.0693 32.3066 43.0693 28.9844C43.0693 25.6621 40.34 22.9688 36.9734 22.9688ZM36.9734 30.625C36.057 30.625 35.3109 29.8888 35.3109 28.9844C35.3109 28.08 36.057 27.3438 36.9734 27.3438C37.8899 27.3438 38.6359 28.08 38.6359 28.9844C38.6359 29.8888 37.8899 30.625 36.9734 30.625ZM42.5151 10.9375H38.0818V8.18946C38.0818 7.22422 38.4073 6.2918 38.9927 5.53438C39.2989 5.13789 39.2386 4.57324 38.9012 4.20205L37.4029 2.54981C36.9416 2.04053 36.1339 2.07676 35.6919 2.60313C34.3813 4.16309 33.6484 6.13936 33.6484 8.18946V10.9375H26.56L22.6746 1.99199C22.4193 1.40057 21.9934 0.896336 21.4498 0.54212C20.9062 0.187904 20.269 -0.000632271 19.6176 1.59305e-06H10.3734C8.53984 1.59305e-06 7.04844 1.47178 7.04844 3.28125V13.2973C6.45063 12.8372 5.59652 12.8557 5.0472 13.3978L2.89219 15.5244C2.29715 16.1116 2.29715 17.0639 2.89219 17.6511L3.2427 17.997C2.89704 18.63 2.62203 19.2835 2.41768 19.9603H1.9224C1.08076 19.9603 0.398438 20.6336 0.398438 21.4642V24.472C0.398438 25.3025 1.08076 25.9759 1.9224 25.9759H2.41699C2.62203 26.6533 2.89634 27.3062 3.24201 27.9398L2.89149 28.2857C2.29646 28.873 2.29646 29.8252 2.89149 30.4124L5.04651 32.5391C5.64155 33.1263 6.60649 33.1263 7.20153 32.5391L7.55204 32.1932C8.19348 32.5343 8.85571 32.8057 9.54149 33.0073V33.4961C9.54149 34.3267 10.2238 35 11.0655 35H14.1134C14.955 35 15.6373 34.3267 15.6373 33.4961V33.008C16.3231 32.8064 16.9853 32.535 17.6268 32.1939L17.9773 32.5397C18.5723 33.127 19.5373 33.127 20.1323 32.5397L22.2873 30.4131C22.8824 29.8259 22.8824 28.8736 22.2873 28.2864L21.9368 27.9405C22.2825 27.3075 22.5575 26.654 22.7618 25.9772H23.2578C24.0995 25.9772 24.7818 25.3039 24.7818 24.4733V24.0632H30.3608C31.8786 22.0814 34.2622 20.7819 36.9734 20.7819C38.2646 20.7819 39.472 21.0971 40.5617 21.6159L44.082 18.1419C44.4976 17.7317 44.7311 17.1753 44.7311 16.5949V13.125C44.7318 11.9171 43.7391 10.9375 42.5151 10.9375ZM12.5901 28.4375C9.52972 28.4375 7.04844 25.9889 7.04844 22.9688C7.04844 19.9486 9.52972 17.5 12.5901 17.5C15.6505 17.5 18.1318 19.9486 18.1318 22.9688C18.1318 25.9889 15.6505 28.4375 12.5901 28.4375ZM14.1141 10.9375H11.4818V4.375H18.8861L21.7366 10.9375H14.1141Z"
        fill={theme.color.neutral_500}
      />
    </svg>
  );
});

export const FailIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_33291)">
        <path
          d="M20 11C20 13.3869 19.0518 15.6761 17.364 17.364C15.6761 19.0518 13.3869 20 11 20C8.61305 20 6.32387 19.0518 4.63604 17.364C2.94821 15.6761 2 13.3869 2 11C2 8.61305 2.94821 6.32387 4.63604 4.63604C6.32387 2.94821 8.61305 2 11 2C13.3869 2 15.6761 2.94821 17.364 4.63604C19.0518 6.32387 20 8.61305 20 11ZM11 6.5C10.8578 6.50008 10.7172 6.52994 10.5873 6.58767C10.4573 6.64539 10.3409 6.7297 10.2455 6.83515C10.1501 6.9406 10.0779 7.06487 10.0335 7.19994C9.98901 7.33501 9.97336 7.47789 9.9875 7.61937L10.3812 11.5647C10.3945 11.7197 10.4654 11.8641 10.58 11.9693C10.6946 12.0746 10.8444 12.1329 11 12.1329C11.1556 12.1329 11.3054 12.0746 11.42 11.9693C11.5346 11.8641 11.6055 11.7197 11.6188 11.5647L12.0125 7.61937C12.0266 7.47789 12.011 7.33501 11.9665 7.19994C11.9221 7.06487 11.8499 6.9406 11.7545 6.83515C11.6591 6.7297 11.5427 6.64539 11.4127 6.58767C11.2828 6.52994 11.1422 6.50008 11 6.5ZM11.0022 13.25C10.7039 13.25 10.4177 13.3685 10.2068 13.5795C9.99578 13.7905 9.87725 14.0766 9.87725 14.375C9.87725 14.6734 9.99578 14.9595 10.2068 15.1705C10.4177 15.3815 10.7039 15.5 11.0022 15.5C11.3006 15.5 11.5868 15.3815 11.7977 15.1705C12.0087 14.9595 12.1272 14.6734 12.1272 14.375C12.1272 14.0766 12.0087 13.7905 11.7977 13.5795C11.5868 13.3685 11.3006 13.25 11.0022 13.25Z"
          fill={theme.color.red_500}
        />
      </g>
      <defs>
        <clipPath id="clip0_726_33291">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

export const SuccessIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8861 2.06641C6.01308 2.06641 2.0625 6.01699 2.0625 10.89C2.0625 15.7631 6.01308 19.7137 10.8861 19.7137C15.7592 19.7137 19.7098 15.7631 19.7098 10.89C19.7098 6.01699 15.7592 2.06641 10.8861 2.06641ZM14.7108 9.39804C14.7812 9.31754 14.8348 9.22376 14.8685 9.12224C14.9021 9.02071 14.9151 8.91347 14.9067 8.80684C14.8983 8.70022 14.8687 8.59634 14.8195 8.50134C14.7704 8.40634 14.7027 8.32212 14.6206 8.25365C14.5384 8.18517 14.4434 8.13382 14.3411 8.10262C14.2388 8.07142 14.1312 8.06099 14.0248 8.07195C13.9184 8.08291 13.8153 8.11504 13.7215 8.16645C13.6277 8.21786 13.5452 8.2875 13.4787 8.37129L10.0294 12.5096L8.24466 10.724C8.09337 10.5779 7.89074 10.497 7.68042 10.4988C7.4701 10.5007 7.26891 10.585 7.12019 10.7338C6.97146 10.8825 6.8871 11.0837 6.88528 11.294C6.88345 11.5043 6.9643 11.7069 7.11042 11.8582L9.51686 14.2647C9.59568 14.3434 9.69004 14.4049 9.79394 14.4452C9.89783 14.4855 10.009 14.5037 10.1203 14.4986C10.2316 14.4936 10.3406 14.4654 10.4405 14.4158C10.5403 14.3663 10.6287 14.2965 10.7 14.2109L14.7108 9.39804Z"
        fill={theme.color.green_500}
      />
    </svg>
  );
});

export const SmallAdminIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 23, height = 23, fill = theme.color.neutral_500 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_722_27567)">
          <path
            d="M15.8125 8.625C15.8125 9.76875 15.3581 10.8656 14.5494 11.6744C13.7406 12.4831 12.6437 12.9375 11.5 12.9375C10.3563 12.9375 9.25935 12.4831 8.4506 11.6744C7.64185 10.8656 7.1875 9.76875 7.1875 8.625C7.1875 7.48125 7.64185 6.38435 8.4506 5.5756C9.25935 4.76685 10.3563 4.3125 11.5 4.3125C12.6437 4.3125 13.7406 4.76685 14.5494 5.5756C15.3581 6.38435 15.8125 7.48125 15.8125 8.625Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11.5C0 8.45001 1.2116 5.52494 3.36827 3.36827C5.52494 1.2116 8.45001 0 11.5 0C14.55 0 17.4751 1.2116 19.6317 3.36827C21.7884 5.52494 23 8.45001 23 11.5C23 14.55 21.7884 17.4751 19.6317 19.6317C17.4751 21.7884 14.55 23 11.5 23C8.45001 23 5.52494 21.7884 3.36827 19.6317C1.2116 17.4751 0 14.55 0 11.5ZM11.5 1.4375C9.60506 1.4376 7.74865 1.97277 6.14445 2.98142C4.54026 3.99006 3.25347 5.43118 2.4322 7.1389C1.61093 8.84663 1.28856 10.7515 1.50219 12.6344C1.71581 14.5173 2.45676 16.3016 3.63975 17.7819C4.66038 16.1374 6.90719 14.375 11.5 14.375C16.0928 14.375 18.3382 16.1359 19.3603 17.7819C20.5432 16.3016 21.2842 14.5173 21.4978 12.6344C21.7114 10.7515 21.3891 8.84663 20.5678 7.1389C19.7465 5.43118 18.4597 3.99006 16.8555 2.98142C15.2513 1.97277 13.3949 1.4376 11.5 1.4375Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_722_27567">
            <rect width="23" height="23" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

// 사용자 계정 관리 아이콘
export const SmallRealAdminIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 23, height = 23, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        fill={fill}
        width={width}
        height={height}
        viewBox="0 0 36 36"
        version="1.1"
        preserveAspectRatio="xMidYMid meet"
      >
        <title>administrator-solid</title>
        <circle fill={fill} cx="14.67" cy="8.3" r="6"></circle>
        <path d="M16.44,31.82a2.15,2.15,0,0,1-.38-2.55l.53-1-1.09-.33A2.14,2.14,0,0,1,14,25.84V23.79a2.16,2.16,0,0,1,1.53-2.07l1.09-.33-.52-1a2.17,2.17,0,0,1,.35-2.52,18.92,18.92,0,0,0-2.32-.16A15.58,15.58,0,0,0,2,23.07v7.75a1,1,0,0,0,1,1H16.44Z"></path>
        <path d="M33.7,23.46l-2-.6a6.73,6.73,0,0,0-.58-1.42l1-1.86a.35.35,0,0,0-.07-.43l-1.45-1.46a.38.38,0,0,0-.43-.07l-1.85,1a7.74,7.74,0,0,0-1.43-.6l-.61-2a.38.38,0,0,0-.36-.25H23.84a.38.38,0,0,0-.35.26l-.6,2a6.85,6.85,0,0,0-1.45.61l-1.81-1a.38.38,0,0,0-.44.06l-1.47,1.44a.37.37,0,0,0-.07.44l1,1.82A7.24,7.24,0,0,0,18,22.83l-2,.61a.36.36,0,0,0-.26.35v2.05a.36.36,0,0,0,.26.35l2,.61a7.29,7.29,0,0,0,.6,1.41l-1,1.9a.37.37,0,0,0,.07.44L19.16,32a.38.38,0,0,0,.44.06l1.87-1a7.09,7.09,0,0,0,1.4.57l.6,2.05a.38.38,0,0,0,.36.26h2.05a.38.38,0,0,0,.35-.26l.6-2.05a6.68,6.68,0,0,0,1.38-.57l1.89,1a.38.38,0,0,0,.44-.06L32,30.55a.38.38,0,0,0,.06-.44l-1-1.88a6.92,6.92,0,0,0,.57-1.38l2-.61a.39.39,0,0,0,.27-.35V23.82A.4.4,0,0,0,33.7,23.46Zm-8.83,4.72a3.34,3.34,0,1,1,3.33-3.34A3.34,3.34,0,0,1,24.87,28.18Z"></path>
        <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
      </svg>
    );
  }
);

// 추가 알림 수신자 관리 아이콘
export const SmallNokIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 23, height = 23, fill = theme.color.neutral_200 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={fill}
          d="M9.5 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
        ></path>
        <path
          fill={fill}
          d="M14.27 4h-2.54c0 0 0 0 0 0-0.955 0-1.73 0.775-1.73 1.73v3.27c0 0.552 0.448 1 1 1v6h4v-6c0.552 0 1-0.448 1-1v-3.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"
        ></path>
        <path
          fill={fill}
          d="M15 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
        ></path>
        <path
          fill={fill}
          d="M4.27 5h-2.54c-0.955 0-1.73 0.775-1.73 1.73s0.775 1.73 1.73 1.73c0.955 0 1.73-0.775 1.73-1.73s-0.775-1.73-1.73-1.73c-0.955 0-1.73 0.775-1.73 1.73v2.27c0 0.552 0.448 1 1 1l-1 3h1v3h4v-3h1l-1-3c0.552 0 1-0.448 1-1v-2.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"
        ></path>
        <path
          fill={fill}
          d="M5 3c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
        ></path>
        <path
          fill={fill}
          d="M7 13v3h2v-3c0.552 0 1-0.448 1-1v-1.54c0-0.806-0.654-1.46-1.46-1.46 0 0 0 0 0 0h-1.080c-0.806 0-1.46 0.654-1.46 1.46 0 0 0 0 0 0v1.54c0 0.552 0.448 1 1 1z"
        ></path>
      </svg>
    );
  }
);

export const LeftArrowIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width = 24, height = 24 }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="5" fill={theme.color.neutral_200} />
      <path
        d="M14.5098 17.8687L8.99932 11.9343L14.5098 6"
        stroke={theme.color.neutral_400}
        strokeWidth="1.69552"
        strokeLinecap="round"
      />
    </svg>
  );
});

export const RightArrowIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(({ width = 24, height = 24 }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="24"
        y="24"
        width="24"
        height="24"
        rx="5"
        transform="rotate(-180 24 24)"
        fill={theme.color.neutral_200}
      />
      <path
        d="M9.49023 6.13135L15.0007 12.0657L9.49023 18"
        stroke={theme.color.neutral_400}
        strokeWidth="1.69552"
        strokeLinecap="round"
      />
    </svg>
  );
});

export const NotBookMarkIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2 16.5001V16.5V3C13.2 2.41652 12.9682 1.85695 12.5556 1.44437C12.1431 1.03179 11.5835 0.8 11 0.8H3C2.41652 0.8 1.85694 1.03179 1.44436 1.44437C1.03178 1.85695 0.8 2.41652 0.8 3L0.8 16.5L0.8 16.5001C0.800065 16.6267 0.834474 16.751 0.89956 16.8596C0.964646 16.9682 1.05797 17.0571 1.1696 17.1169C1.28123 17.1766 1.40697 17.205 1.53345 17.1989C1.65657 17.1931 1.77589 17.1548 1.87938 17.088L7 14.3282L12.1206 17.088C12.2241 17.1548 12.3434 17.1931 12.4666 17.1989C12.593 17.205 12.7188 17.1766 12.8304 17.1169C12.942 17.0571 13.0354 16.9682 13.1004 16.8596C13.1655 16.751 13.1999 16.6267 13.2 16.5001ZM2.43431 2.43431C2.58434 2.28429 2.78783 2.2 3 2.2H11C11.2122 2.2 11.4157 2.28429 11.5657 2.43431C11.7157 2.58434 11.8 2.78783 11.8 3V15.235L7.37842 12.9114C7.2656 12.8389 7.13426 12.8003 7 12.8003C6.86574 12.8003 6.7344 12.8389 6.62158 12.9114L2.2 15.235V3C2.2 2.78783 2.28429 2.58434 2.43431 2.43431Z"
        fill={theme.color.green_500}
        stroke={theme.color.green_500}
        strokeWidth="0.4"
      />
    </svg>
  );
});

export const BookMarkIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2 17.5001V17.5V4C15.2 3.41652 14.9682 2.85695 14.5556 2.44437C14.1431 2.03179 13.5835 1.8 13 1.8H5C4.41652 1.8 3.85694 2.03179 3.44436 2.44437C3.03178 2.85695 2.8 3.41652 2.8 4L2.8 17.5L2.8 17.5001C2.80007 17.6267 2.83447 17.751 2.89956 17.8596C2.96465 17.9682 3.05797 18.0571 3.1696 18.1169C3.28123 18.1766 3.40697 18.205 3.53345 18.1989C3.65657 18.1931 3.77589 18.1548 3.87938 18.088L9 15.3282L14.1206 18.088C14.2241 18.1548 14.3434 18.1931 14.4666 18.1989C14.593 18.205 14.7188 18.1766 14.8304 18.1169C14.942 18.0571 15.0354 17.9682 15.1004 17.8596C15.1655 17.751 15.1999 17.6267 15.2 17.5001ZM4.43431 3.43431C4.58434 3.28429 4.78783 3.2 5 3.2H13C13.2122 3.2 13.4157 3.28429 13.5657 3.43431C13.7157 3.58434 13.8 3.78783 13.8 4V16.235L9.37842 13.9114C9.2656 13.8389 9.13426 13.8003 9 13.8003C8.86574 13.8003 8.7344 13.8389 8.62158 13.9114L4.2 16.235V4C4.2 3.78783 4.28429 3.58434 4.43431 3.43431Z"
        fill={theme.color.green_500}
        stroke={theme.color.green_500}
        strokeWidth="0.4"
      />
      <path
        d="M3 4V17.5C2.99994 17.5868 3.02248 17.6722 3.06542 17.7476C3.10836 17.8231 3.17022 17.8861 3.24489 17.9304C3.31957 17.9747 3.40449 17.9988 3.4913 18.0003C3.57812 18.0018 3.66383 17.9807 3.74 17.939L9 15.069L14.26 17.939C14.3362 17.9807 14.4219 18.0018 14.5087 18.0003C14.5955 17.9988 14.6804 17.9747 14.7551 17.9304C14.8298 17.8861 14.8916 17.8231 14.9346 17.7476C14.9775 17.6722 15.0001 17.5868 15 17.5V4C15 3.46957 14.7893 2.96086 14.4142 2.58579C14.0391 2.21071 13.5304 2 13 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4Z"
        fill={theme.color.green_500}
      />
    </svg>
  );
});

export const PinIcon: React.FC<{}> = memo(() => {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7361 16.7632C11.1988 17.7355 9.8012 17.7355 9.2639 16.7632L5.0787 9.19003C2.79728 5.06174 5.78326 6.17782e-07 10.5 1.01751e-06C15.2167 1.41724e-06 18.2027 5.06175 15.9213 9.19004L11.7361 16.7632Z"
        fill={theme.color.neutral_500}
      />
      <ellipse cx="10.5" cy="6.107" rx="2.1" ry="2.03571" fill="white" />
    </svg>
  );
});

// 배터리 잔량 아이콘
export const Battery5: React.FC<{}> = memo(() => {
  // 100퍼/ 5칸
  return (
    <>
      <svg
        fill={theme.color.pastelGreen_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z M4.078125,9.07373047 L6.078125,9.07373047 L6.078125,15.2611964 L4.078125,15.2611964 L4.078125,9.07373047 Z M7.078125,9.07373047 L9.078125,9.07373047 L9.078125,15.2611964 L7.078125,15.2611964 L7.078125,9.07373047 Z M10.078125,9.07373047 L12.078125,9.07373047 L12.078125,15.2611964 L10.078125,15.2611964 L10.078125,9.07373047 Z M13.078125,9.07373047 L15.078125,9.07373047 L15.078125,15.2611964 L13.078125,15.2611964 L13.078125,9.07373047 Z M16.078125,9.07373047 L18.078125,9.07373047 L18.078125,15.2611964 L16.078125,15.2611964 L16.078125,9.07373047 Z" />
      </svg>
    </>
  );
});

export const Battery4: React.FC<{}> = memo(() => {
  // 4칸
  return (
    <>
      <svg
        fill={theme.color.pastelGreen_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z M4.078125,9.07373047 L6.078125,9.07373047 L6.078125,15.2611964 L4.078125,15.2611964 L4.078125,9.07373047 Z M7.078125,9.07373047 L9.078125,9.07373047 L9.078125,15.2611964 L7.078125,15.2611964 L7.078125,9.07373047 Z M10.078125,9.07373047 L12.078125,9.07373047 L12.078125,15.2611964 L10.078125,15.2611964 L10.078125,9.07373047 Z M13.078125,9.07373047 L15.078125,9.07373047 L15.078125,15.2611964 L13.078125,15.2611964 L13.078125,9.07373047 Z" />
      </svg>
    </>
  );
});

export const Battery3: React.FC<{}> = memo(() => {
  // 3칸
  return (
    <>
      <svg
        fill={theme.color.pastelOrange_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z M4.078125,9.07373047 L6.078125,9.07373047 L6.078125,15.2611964 L4.078125,15.2611964 L4.078125,9.07373047 Z M7.078125,9.07373047 L9.078125,9.07373047 L9.078125,15.2611964 L7.078125,15.2611964 L7.078125,9.07373047 Z M10.078125,9.07373047 L12.078125,9.07373047 L12.078125,15.2611964 L10.078125,15.2611964 L10.078125,9.07373047 Z" />
      </svg>
    </>
  );
});

export const Battery2: React.FC<{}> = memo(() => {
  // 2칸
  return (
    <>
      <svg
        fill={theme.color.pastelOrange_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z M4.078125,9.07373047 L6.078125,9.07373047 L6.078125,15.2611964 L4.078125,15.2611964 L4.078125,9.07373047 Z M7.078125,9.07373047 L9.078125,9.07373047 L9.078125,15.2611964 L7.078125,15.2611964 L7.078125,9.07373047 Z M10.078125,9.07373047 L12.078125,9.07373047 L12.078125,15.2611964 L10.078125,15.2611964 L10.078125,9.07373047 Z" />
      </svg>
    </>
  );
});

export const Battery1: React.FC<{}> = memo(() => {
  // 1칸
  return (
    <>
      <svg
        fill={theme.color.pastelRed_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z M4.078125,9.07373047 L6.078125,9.07373047 L6.078125,15.2611964 L4.078125,15.2611964 L4.078125,9.07373047 Z" />
      </svg>
    </>
  );
});

export const Battery0: React.FC<{}> = memo(() => {
  // 0칸 / 표시
  return (
    <>
      <svg
        fill={theme.color.neutral_500}
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M4.58578644,6 L1.29289322,2.70710678 L2.70710678,1.29289322 L22.7071068,21.2928932 L21.2928932,22.7071068 L16.5857864,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L4.58578644,6 Z M14.5857864,16 L6.58578644,8 L3,8 L3,16 L14.5857864,16 Z M10.2071068,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,16.2371836 20.9587128,16.4647241 20.8829334,16.6758266 L19,14.7928932 L19,8 L12.2071068,8 L10.2071068,6 Z"
        />
      </svg>
    </>
  );
});

// 지도화면 유틸바 열기/닫기 화살표 버튼
export const ArrowForMap: React.FC<{
  rotate: any;
}> = memo((props) => {
  const { rotate } = props;
  return (
    <>
      <svg
        version="1.1"
        // transform={`rotate(${rotate})`}
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9783 5.31877L10.7683 8.52877L8.79828 10.4888C7.96828 11.3188 7.96828 12.6688 8.79828 13.4988L13.9783 18.6788C14.6583 19.3588 15.8183 18.8688 15.8183 17.9188V12.3088V6.07877C15.8183 5.11877 14.6583 4.63877 13.9783 5.31877Z"
          fill={theme.color.white}
          transform={`rotate(${rotate} 15 15)`}
        />
      </svg>
    </>
  );
});

// 사용 리포트 지도 시작 마커
export const MapStartImage: React.FC<{ color?: string }> = memo(
  ({ color }) => {
    return (
      <svg width="40" height="40" viewBox="0 0 37 36" fill="none">
        <circle
          cx="18.8086"
          cy="18"
          r="18"
          fill={color ? color : theme.color.green_500}
        />
        <circle cx="18.8086" cy="18" r="15" fill="white" />
        <path
          d="M11.0006 12.808V14.428C11.0006 16.588 10.0886 18.724 8.15659 19.564L9.10459 20.884C11.3126 19.864 12.2966 17.284 12.2966 14.428V12.808H11.0006ZM11.3126 12.808V14.428C11.3126 17.164 12.2966 19.636 14.4446 20.62L15.3806 19.336C13.4846 18.52 12.6086 16.48 12.6086 14.428V12.808H11.3126ZM15.9086 11.944V23.092H17.5166V11.944H15.9086ZM21.7997 13.096V13.792C21.7997 15.184 21.0197 16.624 19.1597 17.224L19.9877 18.46C22.1117 17.776 23.1077 15.892 23.1077 13.792V13.096H21.7997ZM22.1237 13.096V13.792C22.1237 15.784 23.0837 17.596 25.1597 18.268L25.9757 17.032C24.1757 16.456 23.4197 15.1 23.4197 13.792V13.096H22.1237ZM19.5917 12.604V13.876H25.5917V12.604H19.5917ZM26.4797 11.956V18.652H28.0757V11.956H26.4797ZM27.6317 14.644V15.952H29.5517V14.644H27.6317ZM20.6597 19.132V20.416H26.4797V23.068H28.0757V19.132H20.6597Z"
          fill={color ? color : theme.color.green_500}
        />
      </svg>
    );
  }
);

// 사용 리포트 지도 종료 마커
export const MapEndImage: React.FC<{
  color?: string;
}> = memo(({ color }) => {
  return (
    <svg width="40" height="40" viewBox="0 0 37 36" fill="none">
      <circle
        cx="18.8086"
        cy="18"
        r="18"
        fill={color ? color : theme.color.green_500}
      />
      <circle cx="18.8086" cy="18" r="15" fill="white" />
      <path
        d="M12.8006 15.94V17.956H13.7846V15.94H12.8006ZM8.39659 17.488V18.292H18.2006V17.488H8.39659ZM13.2926 19.18C10.9646 19.18 9.57259 19.852 9.57259 21.052C9.57259 22.252 10.9646 22.912 13.2926 22.912C15.6206 22.912 17.0126 22.252 17.0126 21.052C17.0126 19.852 15.6206 19.18 13.2926 19.18ZM13.2926 19.948C15.0086 19.948 16.0046 20.344 16.0046 21.052C16.0046 21.76 15.0086 22.144 13.2926 22.144C11.5886 22.144 10.5806 21.76 10.5806 21.052C10.5806 20.344 11.5886 19.948 13.2926 19.948ZM12.6566 12.976V13.3C12.6566 14.524 10.8926 15.496 8.93659 15.688L9.29659 16.492C11.5526 16.216 13.5446 15.04 13.5446 13.3V12.976H12.6566ZM13.0766 12.976V13.3C13.0766 15.04 15.0686 16.216 17.3126 16.492L17.6726 15.688C15.7166 15.496 13.9526 14.524 13.9526 13.3V12.976H13.0766ZM9.29659 12.58V13.384H17.3246V12.58H9.29659ZM22.1837 18.448V21.112H23.1677V18.448H22.1837ZM25.6517 18.424V21.1H26.6237V18.424H25.6517ZM19.4477 20.776V21.604H29.2757V20.776H19.4477ZM20.6357 12.892V13.696H27.0797V15.376H20.6717V18.352H21.6557V16.168H28.0637V12.892H20.6357ZM20.6717 17.908V18.724H28.3157V17.908H20.6717Z"
        fill={color ? color : theme.color.green_500}
      />
    </svg>
  );
});

const ping = keyframes`
75%, 100% {
    transform: scale(3.5);
    opacity: 0;
}
`;
const PingContainer = styled.div<{ color: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ::before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${({ color }) => color};
    position: absolute;
    animation: ${ping} 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
`;

// 사용 리포트 지도 종료 마커 (운행중용) - 정상
export const GreenEndMarkerForRunning: React.FC<{}> = memo(() => {
  return (
    <PingContainer color={theme.color.green_500}>
      <svg width="59" height="59" viewBox="0 0 59 59" fill="none">
        <g filter="url(#filter0_d_422_10051)">
          <circle cx="29.087" cy="29.087" r="10.087" fill="white" />
        </g>
        <g filter="url(#filter1_d_422_10051)">
          <circle
            cx="29.0856"
            cy="29.087"
            r="6.30435"
            fill={theme.color.green_500}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_422_10051"
            x="0"
            y="0"
            width="58.1758"
            height="58.1739"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feMorphology
              radius="3"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_422_10051"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="8" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.227451 0 0 0 0 0.843137 0 0 0 0 0.690196 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10051"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10051"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_422_10051"
            x="19.7812"
            y="19.7826"
            width="18.6094"
            height="18.6087"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10051"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10051"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </PingContainer>
  );
});

// 사용 리포트 지도 종료 마커 (운행중용) - 전복
export const RedEndMarkerForRunning: React.FC<{}> = memo(() => {
  return (
    <PingContainer color={theme.color.red_500}>
      <svg width="59" height="59" viewBox="0 0 59 59" fill="none">
        <g filter="url(#filter0_d_422_10326)">
          <circle cx="29.087" cy="29.087" r="10.087" fill="white" />
        </g>
        <g filter="url(#filter1_d_422_10326)">
          <circle
            cx="29.0856"
            cy="29.087"
            r="6.30435"
            fill={theme.color.red_500}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_422_10326"
            x="0"
            y="0"
            width="58.1758"
            height="58.1739"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feMorphology
              radius="3"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_422_10326"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="8" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 0.52549 0 0 0 0 0.521569 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10326"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10326"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_422_10326"
            x="19.7812"
            y="19.7826"
            width="18.6094"
            height="18.6087"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10326"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10326"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </PingContainer>
  );
});

// 사용 리포트 지도 종료 마커 (운행중용) - 전복 외 이벤트
export const OrangeEndMarkerForRunning: React.FC<{}> = memo(() => {
  return (
    <PingContainer color={theme.color.orange_500}>
      <svg width="59" height="59" viewBox="0 0 59 59" fill="none">
        <g filter="url(#filter0_d_422_10274)">
          <circle cx="29.087" cy="29.087" r="10.087" fill="white" />
        </g>
        <g filter="url(#filter1_d_422_10274)">
          <circle
            cx="29.0856"
            cy="29.087"
            r="6.30435"
            fill={theme.color.orange_500}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_422_10274"
            x="0"
            y="0"
            width="58.1758"
            height="58.1739"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feMorphology
              radius="3"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_422_10274"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="8" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 0.643137 0 0 0 0 0.388235 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10274"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10274"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_422_10274"
            x="19.7812"
            y="19.7826"
            width="18.6094"
            height="18.6087"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_422_10274"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_422_10274"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </PingContainer>
  );
});

// 로그인 유지 빈 체크박스
export const CheckBoxEmpty: React.FC<{}> = memo(() => {
  return (
    <svg
      stroke="currentColor"
      fill={theme.color.neutral_400}
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="none" d="M0 0h24v24H0V0z"></path>
      <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
    </svg>
  );
});

// 로그인 유지 체크박스
export const CheckBoxFull: React.FC<{}> = memo(() => {
  return (
    <svg
      stroke="currentColor"
      fill={theme.color.green_500}
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="none" d="M0 0h24v24H0V0z"></path>
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"></path>
    </svg>
  );
});

// 엑스/닫기 버튼
export const XButton: React.FC<{
  width?: string;
  height?: string;
  color?: string;
  onClick?: () => void;
}> = memo((props) => {
  const { width, height, onClick } = props;
  return (
    <XButtonDivBox
      style={{ color: theme.color.neutral_400, width, height }}
      onClick={onClick}
    >
      <svg
        stroke="currentColor"
        fill={theme.color.neutral_400}
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height={height ? height : 40}
        width={width ? width : 40}
      >
        <line
          fill={theme.color.neutral_400}
          x1="18"
          y1="6"
          x2="6"
          y2="18"
        ></line>
        <line
          fill={theme.color.neutral_400}
          x1="6"
          y1="6"
          x2="18"
          y2="18"
        ></line>
      </svg>
    </XButtonDivBox>
  );
});

const XButtonDivBox = styled.button`
  transition: 0.2s;
  &:hover {
    scale: 115%;
  }
`;

// 햄버거메뉴버튼
export const MenuButton: React.FC<{
  width?: string;
  height?: string;
  active?: boolean;
}> = memo((props) => {
  const { active, width = "40px", height = "40px" } = props;
  return (
    <>
      {active ? (
        <MenuButtonDivBox active={active}>
          <svg
            stroke={theme.color.green_500}
            fill="none"
            strokeWidth="2"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
            height={height}
            width={width}
          >
            <line x1="20" y1="2" x2="2" y2="20"></line>
            <line x1="2" y1="2" x2="20" y2="20"></line>
          </svg>
        </MenuButtonDivBox>
      ) : (
        <MenuButtonDivBox active={active}>
          <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M1.25 10H18.75"
              stroke={theme.color.green_500}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.25 17.5H18.75"
              stroke={theme.color.green_500}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.25 2.5H18.75"
              stroke={theme.color.green_500}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </MenuButtonDivBox>
      )}
    </>
  );
});

const MenuButtonDivBox = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ active }) =>
    active ? `rotateY(180deg)` : `rotateY(360deg)`};
  transition: 200ms;
  cursor: pointer;
  &:hover {
    scale: 110%;
  }
`;

// 집 모양 아이콘
export const HomeButton: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = memo((props) => {
  const {
    color = theme.color.green_500,
    width = `32px`,
    height = `32px`,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5L6 0L12 5V11C12 11.5523 11.5523 12 11 12H7.5V9C7.5 8.44771 7.05228 8 6.5 8H5.5C4.94772 8 4.5 8.44771 4.5 9V12H1C0.447715 12 0 11.5523 0 11V5Z"
        fill={color}
      />
    </svg>
  );
});

export const BackButton: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = memo((props) => {
  const { color, width = `60px`, height = `60px` } = props;
  return (
    <svg
      stroke="currentColor"
      fill={color ? color : theme.color.green_500}
      strokeWidth="0"
      version="1.2"
      baseProfile="tiny"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 9.059v-2.559c0-.256-.098-.512-.293-.708-.195-.195-.451-.292-.707-.292s-.512.097-.707.292l-6.293 6.208 6.293 6.207c.195.195.451.293.707.293s.512-.098.707-.293.293-.452.293-.707v-2.489c2.75.068 5.755.566 8 3.989v-1c0-4.633-3.5-8.443-8-8.941z"></path>
    </svg>
  );
});

export const FoldButton: React.FC<{}> = memo(() => {
  return (
    <div
      style={{ transform: "rotate(90deg)", width: "25px", height: "25px" }}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="25"
        width="25"
      >
        <path d="M12 23a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 21.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 23Z"></path>
        <path d="M11.47 1.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 2.81 9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042ZM12 22.25a.75.75 0 0 1-.75-.75v-5.75a.75.75 0 0 1 1.5 0v5.75a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"></path>
        <path d="M12 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 12 1.5Z"></path>
      </svg>
    </div>
  );
});

export const OpenButton: React.FC<{}> = memo(() => {
  return (
    <div
      style={{ transform: "rotate(90deg)", width: "25px", height: "25px" }}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="25"
        width="25"
      >
        <path d="M12 15c.199 0 .389.079.53.22l3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 16.81l-2.72 2.72a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25A.749.749 0 0 1 12 15Z"></path>
        <path d="M12.53 8.78a.75.75 0 0 1-1.06 0L8.22 5.53a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L12 7.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734ZM12 15.75a.75.75 0 0 1 .75.75v5.75a.75.75 0 0 1-1.5 0V16.5a.75.75 0 0 1 .75-.75Z"></path>
        <path d="M12 8.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"></path>
      </svg>
    </div>
  );
});

// 모바일 안전관제 유틸바 활성화/비활성화 버튼
export const ArrowUpDownButton: React.FC<{
  isDisabled?: boolean;
  active?: boolean;
  width?: string;
  height?: string;
}> = memo((props) => {
  const { isDisabled, active, width = 40, height = 40 } = props;
  return (
    <ArrowUpDownButtonDivBox active={active} isDisabled={isDisabled}>
      <svg
        stroke={theme.color.neutral_500}
        fill={theme.color.neutral_500}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height={height}
        width={width}
      >
        <path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"></path>
      </svg>
    </ArrowUpDownButtonDivBox>
  );
});

const ArrowUpDownButtonDivBox = styled.div<{
  active?: boolean;
  isDisabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  transform: ${({ active }) =>
    active ? `rotateX(180deg)` : `rotateX(0deg)`};
  transition: 200ms;
  /* cursor: pointer; */
  cursor: ${({ isDisabled }) => (isDisabled ? "default" : "pointer")};
  &:hover {
    /* scale: 110%; */
    scale: ${({ isDisabled }) => (isDisabled ? "100%" : "110%")};
  }
`;

// 모바일 안전관제 헤더 버튼 - 지도 내 농기계 & 검색바 & 위성
export const DoubleArrowUpDownButton: React.FC<{
  width?: string;
  height?: string;
  active?: boolean;
}> = memo((props) => {
  const { active, width = "40px", height = "40px" } = props;
  return (
    <DoubleArrowUpDownButtonDivBox active={active}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
          d="M11 6L5 12L11 18M18 6L12 12L18 18"
          stroke={theme.color.green_500}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </DoubleArrowUpDownButtonDivBox>
  );
});

const DoubleArrowUpDownButtonDivBox = styled.div<{
  active?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  transform: ${({ active }) =>
    active ? `rotate(270deg)` : `rotate(90deg)`};
  transition: 200ms;
  cursor: pointer;
  &:hover {
    scale: 110%;
  }
`;

export const ScrollTopBottomButton: React.FC<{
  moveTop?: any;
  moveBottom?: any;
}> = memo((props) => {
  const { moveTop, moveBottom } = props;
  return (
    <>
      <ScrollTopBottomButtonContainer>
        {/* 위방향 */}
        <button style={{ cursor: "pointer" }} onClick={() => moveTop()}>
          <svg
            height="30"
            width="30"
            version="1.1"
            id="_x32_"
            viewBox="0 0 512 512"
            fill={theme.color.green_500}
          >
            <g>
              <path
                d="M473.236,283.232L276.228,10.34C271.535,3.855,264.009,0,255.996,0c-8.013,0-15.539,3.855-20.222,10.34
    l-197,272.901c-4.975,7.692-4.78,17.622,0.497,25.1c5.277,7.478,14.546,11.022,23.464,8.938l96.465-22.53v184.81
    c-0.01,17.896,14.517,32.422,32.43,32.422l128.74,0.02c17.924-0.02,32.44-14.546,32.44-32.45V294.73l96.455,22.548
    c8.909,2.084,18.197-1.451,23.465-8.938C477.998,300.853,478.202,290.922,473.236,283.232z"
              />
            </g>
          </svg>
        </button>

        {/* 아래방향 */}
        <button style={{ cursor: "pointer" }} onClick={() => moveBottom()}>
          <svg
            height="30"
            width="30"
            version="1.1"
            id="_x32_"
            viewBox="0 0 512 512"
            fill={theme.color.green_500}
          >
            <g>
              <path
                d="M472.729,203.658c-5.277-7.477-14.546-11.022-23.465-8.938L352.8,217.25V32.44
		c0.009-17.894-14.517-32.422-32.432-32.422L191.628,0c-17.924,0.019-32.44,14.546-32.44,32.44v184.83l-96.455-22.549
		c-8.908-2.084-18.196,1.442-23.464,8.938c-5.267,7.477-5.471,17.408-0.506,25.1l197.01,272.901
		c4.693,6.484,12.219,10.34,20.232,10.34s15.539-3.856,20.222-10.34l197-272.901C478.2,221.066,478.006,211.136,472.729,203.658z"
              />
            </g>
          </svg>
        </button>
      </ScrollTopBottomButtonContainer>
    </>
  );
});

const ScrollTopBottomButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

export const Download: React.FC<{}> = memo(() => {
  return (
    <>
      <svg
        fill={theme.color.neutral_600}
        height="20"
        width="20"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 492 492"
      >
        <g>
          <g>
            <path
              d="M359.28,221.234l-16.12-16.176c-5.064-5.072-11.82-7.888-19.032-7.888c-7.208,0-14.064,2.772-19.128,7.84l-20.492,20.38
			V45.982c-0.008-14.84-12.08-24.888-26.92-24.888h-22.6c-14.836,0-27.376,10.052-27.376,24.892v180.568l-21.288-21.52
			c-5.072-5.068-11.704-7.86-18.916-7.86c-7.208,0-13.908,2.792-18.976,7.86l-16.092,16.12c-5.06,5.068-7.836,11.824-7.836,19.028
			c0,7.208,2.796,13.964,7.86,19.028l94.352,95.272c5.06,5.064,11.812,8.776,19.084,8.776h0.084c7.204,0,13.96-3.716,19.02-8.776
			l94.376-94.836c5.068-5.072,7.852-12.064,7.86-19.264C367.14,233.174,364.348,226.302,359.28,221.234z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M491.716,311.838c0-14.84-11.684-25.472-26.524-25.472H442c-14.84,0-26.916,12.076-26.916,26.912l0.024,80.74H76.996
			l-0.252-80.74c0-14.836-12.076-26.912-26.916-26.912H27.024C12.188,286.366,0,296.518,0,311.354v119.184
			c0,21.2,17.36,40.368,38.56,40.368h414.996c21.196,0,38.444-18.208,38.444-39.416L491.716,311.838z"
            />
          </g>
        </g>
      </svg>
    </>
  );
});

// 차량 전복
export const AccidentMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 67 67" fill="none">
      <circle cx="33.5" cy="33.5" r="30.5" fill={theme.color.red_100} />
      <circle
        cx="33.5"
        cy="33.5"
        r="32"
        stroke={theme.color.red_500}
        strokeOpacity="0.5"
        strokeWidth="3"
      />
      <path
        d="M42.7383 14.8304L45.2602 19.0736L49.9195 17.4442L49.1239 22.3156L53.7405 24.0623L49.9998 27.2827L52.4135 31.5883L47.4779 31.6507L46.5593 36.5004L42.7383 33.3758L38.9173 36.5004L37.9988 31.6507L33.0632 31.5883L35.4769 27.2827L31.7362 24.0623L36.3528 22.3156L35.5572 17.4442L40.2165 19.0736L42.7383 14.8304Z"
        fill={theme.color.red_500}
      />
      <path
        d="M42.8835 22.6652V25.3856"
        stroke="white"
        strokeWidth="1.16071"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8291 28.9397C43.2798 28.9397 43.6452 28.5744 43.6452 28.1236C43.6452 27.6729 43.2798 27.3075 42.8291 27.3075C42.3783 27.3075 42.0129 27.6729 42.0129 28.1236C42.0129 28.5744 42.3783 28.9397 42.8291 28.9397Z"
        fill="white"
      />
      <g clipPath="url(#clip0_716_9699)">
        <path
          d="M40.1563 39.287C38.2172 39.287 36.6451 40.8278 36.6451 42.7283C36.6451 44.6289 38.2172 46.1697 40.1563 46.1697C42.0954 46.1697 43.6675 44.6289 43.6675 42.7283C43.6675 40.8278 42.0954 39.287 40.1563 39.287ZM40.1563 43.6669C39.6284 43.6669 39.1987 43.2457 39.1987 42.7283C39.1987 42.211 39.6284 41.7898 40.1563 41.7898C40.6842 41.7898 41.1139 42.211 41.1139 42.7283C41.1139 43.2457 40.6842 43.6669 40.1563 43.6669ZM43.3483 32.4043H40.7947V30.8323C40.7947 30.2801 40.9822 29.7467 41.3194 29.3134C41.4957 29.0866 41.461 28.7635 41.2667 28.5512L40.4037 27.606C40.1379 27.3147 39.6727 27.3354 39.4181 27.6365C38.6632 28.5289 38.2411 29.6595 38.2411 30.8323V32.4043H34.1582L31.9202 27.2869C31.7732 26.9486 31.5279 26.6601 31.2148 26.4575C30.9017 26.2548 30.5347 26.147 30.1595 26.1473H24.8349C23.7787 26.1473 22.9197 26.9893 22.9197 28.0244V33.7543C22.5753 33.4911 22.0834 33.5016 21.767 33.8117L20.5257 35.0283C20.183 35.3643 20.183 35.909 20.5257 36.2449L20.7276 36.4428C20.5285 36.8049 20.3701 37.1788 20.2524 37.5659H19.9671C19.4823 37.5659 19.0893 37.9511 19.0893 38.4263V40.1469C19.0893 40.6221 19.4823 41.0073 19.9671 41.0073H20.252C20.3701 41.3948 20.5281 41.7683 20.7272 42.1308L20.5253 42.3287C20.1826 42.6646 20.1826 43.2093 20.5253 43.5453L21.7666 44.7618C22.1093 45.0978 22.6651 45.0978 23.0079 44.7618L23.2098 44.564C23.5792 44.7591 23.9607 44.9144 24.3557 45.0297V45.3093C24.3557 45.7845 24.7487 46.1697 25.2335 46.1697H26.989C27.4738 46.1697 27.8668 45.7845 27.8668 45.3093V45.0301C28.2618 44.9147 28.6433 44.7595 29.0127 44.5644L29.2146 44.7622C29.5574 45.0982 30.1132 45.0982 30.4559 44.7622L31.6972 43.5456C32.0399 43.2097 32.0399 42.665 31.6972 42.3291L31.4953 42.1312C31.6944 41.7691 31.8528 41.3952 31.9705 41.008H32.2562C32.741 41.008 33.134 40.6229 33.134 40.1477V39.9131H36.3475C37.2217 38.7794 38.5946 38.036 40.1563 38.036C40.9 38.036 41.5955 38.2163 42.2231 38.5131L44.2508 36.5257C44.4902 36.2911 44.6246 35.9727 44.6246 35.6407V33.6557C44.625 32.9647 44.0533 32.4043 43.3483 32.4043ZM26.1116 42.4155C24.3489 42.4155 22.9197 41.0147 22.9197 39.287C22.9197 37.5593 24.3489 36.1585 26.1116 36.1585C27.8744 36.1585 29.3036 37.5593 29.3036 39.287C29.3036 41.0147 27.8744 42.4155 26.1116 42.4155ZM26.9894 32.4043H25.4733V28.6501H29.7381L31.38 32.4043H26.9894Z"
          fill={theme.color.neutral_600}
        />
      </g>
      <defs>
        <clipPath id="clip0_716_9699">
          <rect
            width="25.5357"
            height="20.0223"
            fill="white"
            transform="translate(19.0893 26.1473)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

// 배터리 부족
export const WarningBatteryMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 67 67" fill="none">
      <circle cx="33.5" cy="33.5" r="30.5" fill={theme.color.orange_100} />
      <circle
        cx="33.5"
        cy="33.5"
        r="32"
        stroke={theme.color.orange_500}
        strokeOpacity="0.5"
        strokeWidth="3"
      />
      <path
        d="M39.4554 24.1172L25.0022 24.1172C23.8619 24.1172 22.9375 25.0416 22.9375 26.1819L22.9375 45.7969C22.9375 46.9372 23.8619 47.8616 25.0022 47.8616L39.4554 47.8616C40.5957 47.8616 41.5201 46.9372 41.5201 45.7969L41.5201 26.1819C41.5201 25.0416 40.5957 24.1172 39.4554 24.1172Z"
        stroke={theme.color.neutral_600}
        strokeWidth="1.79961"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="25.6922"
        y="45.4163"
        width="8.35532"
        height="13.3685"
        rx="1.28543"
        transform="rotate(-90 25.6922 45.4163)"
        fill={theme.color.orange_500}
      />
      <path
        d="M27.0291 22.0207C27.0291 21.0978 27.7773 20.3496 28.7002 20.3496H35.7186C36.6415 20.3496 37.3897 21.0978 37.3897 22.0207V23.6917H27.0291V22.0207Z"
        fill={theme.color.neutral_600}
      />
      <path
        d="M42.3206 16.1291L35.4293 28.0348C35.3191 28.2253 35.2609 28.4415 35.2607 28.6616C35.2606 28.8818 35.3184 29.098 35.4283 29.2887C35.5383 29.4794 35.6965 29.6378 35.8871 29.7479C36.0777 29.858 36.2939 29.916 36.514 29.916H50.2966C50.5167 29.916 50.7329 29.858 50.9235 29.7479C51.1141 29.6378 51.2724 29.4794 51.3823 29.2887C51.4923 29.098 51.5501 28.8818 51.5499 28.6616C51.5497 28.4415 51.4916 28.2253 51.3813 28.0348L44.49 16.1291C44.3799 15.9389 44.2218 15.781 44.0314 15.6712C43.841 15.5614 43.6251 15.5037 43.4053 15.5037C43.1856 15.5037 42.9697 15.5614 42.7793 15.6712C42.5889 15.781 42.4307 15.9389 42.3206 16.1291Z"
        fill={theme.color.yellow_500}
      />
      <path
        d="M43.4053 21.1436V24.2768"
        stroke={theme.color.neutral_600}
        strokeWidth="1.33685"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4054 28.0367C43.9245 28.0367 44.3453 27.6158 44.3453 27.0967C44.3453 26.5776 43.9245 26.1567 43.4054 26.1567C42.8862 26.1567 42.4654 26.5776 42.4654 27.0967C42.4654 27.6158 42.8862 28.0367 43.4054 28.0367Z"
        fill={theme.color.neutral_600}
      />
    </svg>
  );
});

// 사용지역이탈
export const WarningEscapeMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 67 67" fill="none">
      <circle cx="33.5" cy="33.5" r="30.5" fill={theme.color.orange_100} />
      <circle
        cx="33.5"
        cy="33.5"
        r="32"
        stroke={theme.color.orange_500}
        strokeOpacity="0.5"
        strokeWidth="3"
      />
      <ellipse
        cx="32.9643"
        cy="46.7589"
        rx="15.2679"
        ry="4.24107"
        fill={theme.color.pastelRed_200} // 그림자
      />
      <path
        d="M32.9627 20.4644C27.3475 20.4644 22.7841 25.0277 22.7841 30.6429C22.7841 34.0697 24.769 36.9367 27.0761 38.9385C27.8056 39.5661 29.0779 40.567 30.2145 42.0429C31.0479 43.1354 31.829 45.0405 32.3641 46.5452C32.5553 47.0827 33.3702 47.0827 33.5613 46.5452C34.0965 45.0405 34.8775 43.1354 35.7109 42.0429C36.8475 40.567 38.1199 39.5661 38.8493 38.9385C41.1565 36.9367 43.1413 34.0697 43.1413 30.6429C43.1413 25.0277 38.5779 20.4644 32.9627 20.4644ZM32.9627 24.8072C33.7291 24.8072 34.4879 24.9582 35.196 25.2514C35.904 25.5447 36.5473 25.9746 37.0892 26.5165C37.6311 27.0584 38.0609 27.7017 38.3542 28.4097C38.6475 29.1177 38.7984 29.8766 38.7984 30.6429C38.7984 31.4093 38.6475 32.1681 38.3542 32.8762C38.0609 33.5842 37.6311 34.2275 37.0892 34.7694C36.5473 35.3113 35.904 35.7412 35.196 36.0344C34.4879 36.3277 33.7291 36.4786 32.9627 36.4786C31.415 36.4786 29.9307 35.8638 28.8362 34.7694C27.7418 33.675 27.127 32.1907 27.127 30.6429C27.127 29.0952 27.7418 27.6109 28.8362 26.5165C29.9307 25.422 31.415 24.8072 32.9627 24.8072Z"
        fill={theme.color.orange_500}
      />
      <path
        d="M42.7203 16.1796L35.7244 28.2661C35.6124 28.4595 35.5534 28.6789 35.5532 28.9024C35.553 29.1258 35.6117 29.3454 35.7233 29.539C35.835 29.7326 35.9956 29.8933 36.1891 30.0051C36.3826 30.1169 36.6021 30.1758 36.8255 30.1758H50.8173C51.0408 30.1758 51.2603 30.1169 51.4538 30.0051C51.6473 29.8934 51.8079 29.7326 51.9195 29.539C52.0311 29.3454 52.0898 29.1258 52.0896 28.9024C52.0894 28.6789 52.0304 28.4595 51.9185 28.2661L44.9226 16.1796C44.8108 15.9865 44.6503 15.8262 44.457 15.7148C44.2637 15.6033 44.0445 15.5447 43.8214 15.5447C43.5983 15.5447 43.3791 15.6033 43.1859 15.7148C42.9926 15.8262 42.832 15.9865 42.7203 16.1796Z"
        fill={theme.color.yellow_500}
      />
      <path
        d="M43.8214 21.27V24.4508"
        stroke={theme.color.neutral_600}
        strokeWidth="1.35714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.8214 28.2679C44.3484 28.2679 44.7757 27.8406 44.7757 27.3136C44.7757 26.7866 44.3484 26.3594 43.8214 26.3594C43.2944 26.3594 42.8672 26.7866 42.8672 27.3136C42.8672 27.8406 43.2944 28.2679 43.8214 28.2679Z"
        fill={theme.color.neutral_600}
      />
    </svg>
  );
});

// 위험지역진입
export const DangerousAreaMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 67 67" fill="none">
      <circle cx="33.5" cy="33.5" r="30.5" fill={theme.color.orange_100} />
      <circle
        cx="33.5"
        cy="33.5"
        r="32"
        stroke={theme.color.orange_500}
        strokeOpacity="0.5"
        strokeWidth="3"
      />
      <path
        d="M46.7589 33.4554C46.7589 40.8447 40.7688 46.8349 33.3795 46.8349C25.9902 46.8349 20 40.8447 20 33.4554C20 26.0661 25.9902 20.0759 33.3795 20.0759C40.7688 20.0759 46.7589 26.0661 46.7589 33.4554Z"
        fill={theme.color.orange_500}
      />
      <path
        d="M23.8771 32.4473C23.8771 32.1799 23.9772 31.9235 24.1554 31.7345C24.3336 31.5454 24.5753 31.4392 24.8273 31.4392H41.9297C42.1817 31.4392 42.4234 31.5454 42.6016 31.7345C42.7798 31.9235 42.8799 32.1799 42.8799 32.4473V34.4633C42.8799 34.7307 42.7798 34.9871 42.6016 35.1761C42.4234 35.3652 42.1817 35.4714 41.9297 35.4714H24.8273C24.5753 35.4714 24.3336 35.3652 24.1554 35.1761C23.9772 34.9871 23.8771 34.7307 23.8771 34.4633V32.4473Z"
        fill="white"
      />
      <path
        d="M45.0255 13.2611L38.2137 25.0294C38.1047 25.2177 38.0472 25.4314 38.0471 25.649C38.0469 25.8666 38.104 26.0804 38.2127 26.2689C38.3214 26.4574 38.4778 26.6139 38.6662 26.7227C38.8546 26.8316 39.0683 26.8889 39.2859 26.8889H52.9095C53.127 26.8889 53.3408 26.8316 53.5292 26.7227C53.7176 26.6139 53.874 26.4574 53.9827 26.2689C54.0914 26.0804 54.1485 25.8666 54.1483 25.649C54.1481 25.4314 54.0906 25.2177 53.9816 25.0294L47.1699 13.2611C47.061 13.0731 46.9047 12.917 46.7165 12.8085C46.5283 12.6999 46.3149 12.6428 46.0977 12.6428C45.8804 12.6428 45.667 12.6999 45.4788 12.8085C45.2907 12.917 45.1343 13.0731 45.0255 13.2611Z"
        fill={theme.color.yellow_500}
      />
      <path
        d="M46.0983 18.2175V21.3146"
        stroke={theme.color.neutral_600}
        strokeWidth="1.32143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.0983 25.0314C46.6114 25.0314 47.0274 24.6154 47.0274 24.1022C47.0274 23.5891 46.6114 23.1731 46.0983 23.1731C45.5851 23.1731 45.1691 23.5891 45.1691 24.1022C45.1691 24.6154 45.5851 25.0314 46.0983 25.0314Z"
        fill={theme.color.neutral_600}
      />
    </svg>
  );
});

// 위험 운전
export const DangerousDrivingMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="33.5" cy="33.5" r="30.5" fill={theme.color.orange_100} />
      <circle
        cx="33.5"
        cy="33.5"
        r="32"
        stroke={theme.color.orange_500}
        strokeOpacity="0.5"
        strokeWidth="3"
      />
      <g clipPath="url(#clip0_13_5971)">
        <path
          d="M43.067 37.1397C41.1278 37.1397 39.5558 38.6804 39.5558 40.581C39.5558 42.4815 41.1278 44.0223 43.067 44.0223C45.0061 44.0223 46.5781 42.4815 46.5781 40.581C46.5781 38.6804 45.0061 37.1397 43.067 37.1397ZM43.067 41.5195C42.5391 41.5195 42.1094 41.0984 42.1094 40.581C42.1094 40.0636 42.5391 39.6424 43.067 39.6424C43.5948 39.6424 44.0246 40.0636 44.0246 40.581C44.0246 41.0984 43.5948 41.5195 43.067 41.5195ZM46.2589 30.257H43.7054V28.6849C43.7054 28.1327 43.8929 27.5993 44.23 27.166C44.4064 26.9392 44.3717 26.6162 44.1774 26.4039L43.3143 25.4587C43.0486 25.1673 42.5834 25.188 42.3288 25.4892C41.5739 26.3816 41.1518 27.5121 41.1518 28.6849V30.257H37.0689L34.8309 25.1396C34.6839 24.8012 34.4385 24.5128 34.1254 24.3101C33.8123 24.1075 33.4453 23.9996 33.0701 24H27.7455C26.6894 24 25.8304 24.842 25.8304 25.8771V31.6069C25.486 31.3437 24.9941 31.3543 24.6777 31.6644L23.4364 32.881C23.0936 33.2169 23.0936 33.7617 23.4364 34.0976L23.6383 34.2955C23.4392 34.6576 23.2808 35.0314 23.1631 35.4186H22.8778C22.393 35.4186 22 35.8038 22 36.2789V37.9996C22 38.4747 22.393 38.8599 22.8778 38.8599H23.1627C23.2808 39.2475 23.4388 39.6209 23.6379 39.9834L23.436 40.1813C23.0932 40.5172 23.0932 41.062 23.436 41.3979L24.6773 42.6145C25.02 42.9504 25.5758 42.9504 25.9185 42.6145L26.1204 42.4166C26.4899 42.6118 26.8713 42.767 27.2663 42.8824V43.162C27.2663 43.6371 27.6594 44.0223 28.1441 44.0223H29.8997C30.3845 44.0223 30.7775 43.6371 30.7775 43.162V42.8828C31.1725 42.7674 31.5539 42.6122 31.9234 42.417L32.1253 42.6149C32.468 42.9508 33.0238 42.9508 33.3666 42.6149L34.6079 41.3983C34.9506 41.0624 34.9506 40.5176 34.6079 40.1817L34.406 39.9838C34.6051 39.6217 34.7635 39.2479 34.8812 38.8607H35.1669C35.6516 38.8607 36.0446 38.4755 36.0446 38.0004V37.7657H39.2582C40.1324 36.6321 41.5053 35.8886 43.067 35.8886C43.8107 35.8886 44.5061 36.0689 45.1338 36.3657L47.1615 34.3784C47.4009 34.1437 47.5353 33.8254 47.5353 33.4934V31.5084C47.5357 30.8174 46.964 30.257 46.2589 30.257ZM29.0223 40.2681C27.2596 40.2681 25.8304 38.8674 25.8304 37.1397C25.8304 35.4119 27.2596 34.0112 29.0223 34.0112C30.7851 34.0112 32.2143 35.4119 32.2143 37.1397C32.2143 38.8674 30.7851 40.2681 29.0223 40.2681ZM29.9001 30.257H28.3839V26.5028H32.6488L34.2907 30.257H29.9001Z"
          fill="#484848"
        />
      </g>
      <path
        d="M42.3206 16.1291L35.4293 28.0348C35.3191 28.2253 35.2609 28.4415 35.2607 28.6616C35.2606 28.8818 35.3184 29.098 35.4283 29.2887C35.5383 29.4794 35.6965 29.6378 35.8871 29.7479C36.0777 29.858 36.2939 29.916 36.514 29.916H50.2966C50.5167 29.916 50.7329 29.858 50.9235 29.7479C51.1141 29.6378 51.2724 29.4794 51.3823 29.2887C51.4923 29.098 51.5501 28.8818 51.5499 28.6616C51.5497 28.4415 51.4916 28.2253 51.3813 28.0348L44.49 16.1291C44.3799 15.9389 44.2218 15.781 44.0314 15.6712C43.841 15.5614 43.6251 15.5037 43.4053 15.5037C43.1856 15.5037 42.9697 15.5614 42.7793 15.6712C42.5889 15.781 42.4307 15.9389 42.3206 16.1291V16.1291Z"
        fill="#FFCE70"
      />
      <path
        d="M43.4053 21.1436V24.2768"
        stroke="#484848"
        strokeWidth="1.33685"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4053 28.0367C43.9244 28.0367 44.3453 27.6158 44.3453 27.0967C44.3453 26.5776 43.9244 26.1567 43.4053 26.1567C42.8862 26.1567 42.4653 26.5776 42.4653 27.0967C42.4653 27.6158 42.8862 28.0367 43.4053 28.0367Z"
        fill="#484848"
      />
      <defs>
        <clipPath id="clip0_13_5971">
          <rect
            width="25.5357"
            height="20.0223"
            fill="white"
            transform="translate(22 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

// 시동 방치
export const IdleTimeMarker = memo(
  ({
    width = "61px",
    height = "61px",
  }: {
    width?: string;
    height?: string;
  }) => {
    return (
      <svg
        width={width}
        height={height}
        x="0px"
        y="0px"
        viewBox="0 0 62 62"
        enableBackground={`0 0 62 62`}
      >
        <circle
          fill={theme.color.orange_500}
          opacity={0.5}
          cx="31"
          cy="31"
          r="31"
        />
        <circle fill={theme.color.orange_100} cx="31" cy="31" r="28.5" />
        <ellipse
          fill="#FFDEDB"
          fillRule="evenodd"
          clipRule={`evenodd`}
          cx="31"
          cy="43.38"
          rx="15.49"
          ry="4.21"
        />
        <path
          fill="#EE6F2C"
          d="M42.7,39.16l-9.53-10.04l3.43-2.47c1.06-0.76,1.16-2.12,0.27-2.98l-6.91-6.69c-0.57-0.55-1.66-0.52-2.46,0.06
	l-8.78,6.32c-0.8,0.58-1.18,1.6-0.84,2.32l4.16,8.67c0.54,1.12,1.85,1.46,2.91,0.69l2.99-2.15c0.22-0.05,0.45-0.11,0.67-0.18
	c0.14-0.05,0.31-0.01,0.42,0.1l2.96,3.11c0.15,0.16,0.35,0.27,0.57,0.31l2.12,0.43c0.18,0.02,0.32,0.16,0.35,0.35l0.17,1.45
	c0.05,0.44,0.41,0.77,0.85,0.8c0.77,0.04,1.38,0.67,1.39,1.45l0.01,0.55c0,0.27,0.11,0.53,0.3,0.72l0.94,0.99
	c0.2,0.21,0.47,0.33,0.75,0.34l2.4,0.06c0.59,0.02,1.09-0.45,1.11-1.05l0.06-2.4C43,39.64,42.89,39.37,42.7,39.16z"
        />
        <g>
          <path
            fill="#FFCE70"
            fillRule="evenodd"
            clipRule={`evenodd`}
            d="M40.01,15.62L33.66,26.6c-0.44,0.76,0.11,1.71,0.99,1.71h12.68c0.88,0,1.42-0.95,0.99-1.71l-6.34-10.98
		C41.54,14.86,40.44,14.86,40.01,15.62z"
          />
          <path
            fill="#484848"
            fillRule="evenodd"
            clipRule={`evenodd`}
            d="M40.99,23.66L40.99,23.66c-0.37,0-0.68-0.3-0.68-0.67v-3.15c0-0.37,0.3-0.67,0.67-0.67h0
		c0.37,0,0.67,0.3,0.67,0.67v3.15C41.67,23.36,41.36,23.66,40.99,23.66z"
          />
          <circle
            fill="#484848"
            fillRule="evenodd"
            clipRule={`evenodd`}
            cx="40.99"
            cy="25.91"
            r="0.94"
          />
        </g>
        <path
          fill="#FFF6F7"
          fillRule="evenodd"
          clipRule={`evenodd`}
          d="M37.31,35.73L37.31,35.73c-0.15,0.14-0.39,0.13-0.53-0.02l-4.12-4.49c-0.14-0.15-0.13-0.39,0.02-0.53v0
	c0.15-0.14,0.39-0.13,0.53,0.02l4.12,4.49C37.47,35.36,37.46,35.59,37.31,35.73z"
        />
        <circle
          fill="#FFF6F7"
          fillRule="evenodd"
          clipRule={`evenodd`}
          cx="38.13"
          cy="36.41"
          r="0.4"
        />
        <path
          fill="#FFF6F7"
          fillRule="evenodd"
          clipRule={`evenodd`}
          d="M29.6,21.56l-7.38,5.2c-0.69,0.49-1.64,0.32-2.13-0.37l0,0c-0.49-0.69-0.32-1.64,0.37-2.13l7.38-5.2
	c0.69-0.49,1.64-0.32,2.13,0.37l0,0C30.46,20.12,30.29,21.07,29.6,21.56z"
        />
      </svg>
    );
  }
);

// 도난 감지
export const LockOpenMarker = memo(
  ({
    width = "61px",
    height = "61px",
  }: {
    width?: string;
    height?: string;
  }) => {
    return (
      <svg
        width={width}
        height={height}
        x="0px"
        y="0px"
        viewBox="0 0 62 62"
        enableBackground={`0 0 62 62`}
      >
        <circle
          fill={theme.color.orange_500}
          opacity={0.5}
          cx="31"
          cy="31"
          r="31"
        />
        <circle fill={theme.color.orange_100} cx="31" cy="31" r="28.5" />
        <path
          d="M16.5176 7.2677C18.708 7.2677 20.8087 8.13783 22.3575 9.68668C23.9064 11.2355 24.7765 13.3362 24.7765 15.5266V18.8302C25.6527 18.8302 26.4929 19.1783 27.1125 19.7978C27.732 20.4173 28.0801 21.2576 28.0801 22.1338V30.3927C28.0801 31.2689 27.732 32.1091 27.1125 32.7287C26.4929 33.3482 25.6527 33.6963 24.7765 33.6963H8.25865C7.38249 33.6963 6.54221 33.3482 5.92267 32.7287C5.30313 32.1091 4.95508 31.2689 4.95508 30.3927V22.1338C4.95508 21.2576 5.30313 20.4173 5.92267 19.7978C6.54221 19.1783 7.38249 18.8302 8.25865 18.8302H21.4729V15.5266C21.4733 14.3202 21.0336 13.1551 20.2363 12.2498C19.439 11.3445 18.3387 10.7611 17.1419 10.6091C15.9452 10.4571 14.734 10.7469 13.7357 11.4241C12.7373 12.1014 12.0203 13.1196 11.7191 14.2878C11.6096 14.7121 11.336 15.0755 10.9586 15.298C10.7717 15.4082 10.5649 15.4806 10.3501 15.5109C10.1352 15.5411 9.91652 15.5288 9.70644 15.4746C9.49636 15.4204 9.29901 15.3253 9.12567 15.1948C8.95234 15.0643 8.8064 14.9009 8.69619 14.714C8.58599 14.5271 8.51367 14.3204 8.48338 14.1055C8.45308 13.8907 8.4654 13.672 8.51963 13.4619C8.97794 11.6891 10.0121 10.1188 11.4598 8.99767C12.9075 7.87651 14.6865 7.26799 16.5176 7.2677Z"
          fill="#484848"
          transform="translate(14, 10)"
        />
        <path
          d="M27.1125 19.7978C26.4929 19.1783 25.6527 18.8302 24.7765 18.8302H8.25865C7.38249 18.8302 6.54221 19.1783 5.92267 19.7978C5.30313 20.4173 4.95508 21.2576 4.95508 22.1338V30.3927C4.95508 31.2689 5.30313 32.1091 5.92267 32.7287C6.54221 33.3482 7.38249 33.6963 8.25865 33.6963H24.7765C25.6527 33.6963 26.4929 33.3482 27.1125 32.7287C27.732 32.1091 28.0801 31.2689 28.0801 30.3927V22.1338C28.0801 21.2576 27.732 20.4173 27.1125 19.7978Z"
          fill="#FF4341"
          transform="translate(14, 10)"
        />
        <rect
          x="5.39404"
          y="9.5802"
          width="2.64286"
          height="1.65179"
          rx="0.825893"
          transform="translate(14, 10) rotate(60 5.39404 9.5802)"
          fill="#9C9C9C"
        />
        <rect
          x="1.81689"
          y="11.8927"
          width="2.64286"
          height="1.65179"
          rx="0.825893"
          transform="translate(14, 10) rotate(30 1.81689 11.8927)"
          fill="#9C9C9C"
        />
        <rect
          x="0.990723"
          y="16.541"
          width="2.64286"
          height="1.65179"
          rx="0.825893"
          transform="translate(14, 10) rotate(-15 0.990723 16.541)"
          fill="#9C9C9C"
        />
        <rect
          x="7.59814"
          y="21.1427"
          width="1.98214"
          height="7.26786"
          rx="0.991071"
          fill="#FFF6F5"
          transform="translate(14, 10)"
        />
        <rect
          x="7.59814"
          y="29.4016"
          width="1.98214"
          height="1.98214"
          rx="0.991071"
          fill="#FFF6F5"
          transform="translate(14, 10)"
        />
        <path
          d="M26.018 3.09578L19.2062 14.8642C19.0972 15.0525 19.0397 15.2662 19.0396 15.4837C19.0394 15.7013 19.0965 15.9151 19.2052 16.1036C19.3139 16.2921 19.4703 16.4486 19.6587 16.5575C19.8471 16.6663 20.0608 16.7236 20.2784 16.7236H33.9019C34.1195 16.7236 34.3333 16.6663 34.5217 16.5575C34.7101 16.4486 34.8665 16.2921 34.9752 16.1036C35.0838 15.9151 35.141 15.7013 35.1408 15.4837C35.1406 15.2662 35.0831 15.0525 34.9741 14.8642L28.1624 3.09578C28.0535 2.90777 27.8972 2.75168 27.709 2.64317C27.5208 2.53466 27.3074 2.47754 27.0902 2.47754C26.8729 2.47754 26.6595 2.53466 26.4713 2.64317C26.2832 2.75168 26.1268 2.90777 26.018 3.09578Z"
          fill="#FFCE70"
          transform="translate(14, 10)"
        />
        <path
          d="M27.0903 8.05237V11.1495"
          stroke="#484848"
          strokeWidth="1.32143"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(14, 10)"
        />
        <path
          d="M27.0903 14.8661C27.6034 14.8661 28.0194 14.4501 28.0194 13.9369C28.0194 13.4238 27.6034 13.0078 27.0903 13.0078C26.5771 13.0078 26.1611 13.4238 26.1611 13.9369C26.1611 14.4501 26.5771 14.8661 27.0903 14.8661Z"
          fill="#484848"
          transform="translate(14, 10)"
        />
      </svg>
    );
  }
);

// 정상 (통계)
export const NomalMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="17" r="15" fill={theme.color.green_100} />
      <circle
        cx="17"
        cy="17"
        r="15.94"
        stroke={theme.color.pastelGreen_500}
        strokeOpacity="0.7"
        strokeWidth="1.88"
      />
      <g clipPath="url(#clip0_1_5835)">
        <path
          d="M21.377 18.7147C20.2379 18.7147 19.3145 19.6198 19.3145 20.7362C19.3145 21.8526 20.2379 22.7577 21.377 22.7577C22.516 22.7577 23.4395 21.8526 23.4395 20.7362C23.4395 19.6198 22.516 18.7147 21.377 18.7147ZM21.377 21.2875C21.0669 21.2875 20.8145 21.0401 20.8145 20.7362C20.8145 20.4323 21.0669 20.1849 21.377 20.1849C21.687 20.1849 21.9395 20.4323 21.9395 20.7362C21.9395 21.0401 21.687 21.2875 21.377 21.2875ZM23.252 14.6718H21.752V13.7483C21.752 13.424 21.8621 13.1106 22.0602 12.8561C22.1638 12.7229 22.1434 12.5331 22.0292 12.4084L21.5223 11.8532C21.3662 11.682 21.0929 11.6942 20.9434 11.8711C20.4999 12.3953 20.252 13.0594 20.252 13.7483V14.6718H17.8536L16.539 11.6657C16.4526 11.467 16.3085 11.2975 16.1246 11.1785C15.9407 11.0595 15.7251 10.9961 15.5047 10.9963H12.377C11.7566 10.9963 11.252 11.4909 11.252 12.099V15.4647C11.0497 15.3101 10.7607 15.3163 10.5748 15.4985L9.8457 16.2131C9.64438 16.4105 9.64438 16.7305 9.8457 16.9278L9.9643 17.044C9.84734 17.2567 9.7543 17.4763 9.68516 17.7038H9.51758C9.23281 17.7038 9.00195 17.93 9.00195 18.2091V19.2199C9.00195 19.499 9.23281 19.7252 9.51758 19.7252H9.68492C9.7543 19.9529 9.84711 20.1723 9.96406 20.3852L9.84547 20.5015C9.64414 20.6988 9.64414 21.0188 9.84547 21.2161L10.5746 21.9307C10.7759 22.1281 11.1024 22.1281 11.3038 21.9307L11.4223 21.8145C11.6394 21.9291 11.8634 22.0203 12.0955 22.0881V22.2523C12.0955 22.5314 12.3263 22.7577 12.6111 22.7577H13.6423C13.9271 22.7577 14.158 22.5314 14.158 22.2523V22.0883C14.39 22.0206 14.6141 21.9294 14.8311 21.8147L14.9497 21.931C15.151 22.1283 15.4775 22.1283 15.6788 21.931L16.408 21.2163C16.6093 21.019 16.6093 20.699 16.408 20.5017L16.2894 20.3854C16.4063 20.1727 16.4994 19.9531 16.5685 19.7257H16.7363C17.0211 19.7257 17.252 19.4994 17.252 19.2203V19.0825H19.1396C19.6531 18.4166 20.4596 17.9799 21.377 17.9799C21.8138 17.9799 22.2223 18.0858 22.591 18.2601L23.7821 17.0927C23.9227 16.9549 24.0017 16.7679 24.0017 16.5729V15.4069C24.002 15.0009 23.6661 14.6718 23.252 14.6718ZM13.127 20.5524C12.0915 20.5524 11.252 19.7296 11.252 18.7147C11.252 17.6999 12.0915 16.877 13.127 16.877C14.1624 16.877 15.002 17.6999 15.002 18.7147C15.002 19.7296 14.1624 20.5524 13.127 20.5524ZM13.6426 14.6718H12.752V12.4665H15.2572L16.2216 14.6718H13.6426Z"
          fill={theme.color.neutral_600}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_5835">
          <rect
            width="15"
            height="11.7614"
            fill="white"
            transform="translate(9 11)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

// 총 감지내역 (통계)
export const TotalEventsMarker: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="17" r="15" fill={theme.color.red_100} />
      <circle
        cx="17"
        cy="17"
        r="15.9375"
        stroke={theme.color.red_500}
        strokeOpacity="0.5"
        strokeWidth="1.875"
      />
      <path
        d="M13.4473 15.4208C13.4473 13.4587 15.0378 11.8682 16.9999 11.8682V11.8682C18.962 11.8682 20.5525 13.4587 20.5525 15.4208V19.684H13.4473V15.4208Z"
        fill={theme.color.red_500}
      />
      <path
        d="M16.2871 16.8416C16.2871 16.4492 16.6052 16.1311 16.9976 16.1311V16.1311C17.39 16.1311 17.7082 16.4492 17.7082 16.8416V19.6837H16.2871V16.8416Z"
        fill={theme.color.red_100}
      />
      <path
        d="M12.0254 21.263C12.0254 20.391 12.7323 19.6841 13.6043 19.6841H20.3938C21.2658 19.6841 21.9728 20.391 21.9728 21.263V22.5262H12.0254V21.263Z"
        fill={theme.color.neutral_200}
      />
      <path
        d="M20.5524 19.6841V15.4209C20.5524 14.4787 20.1781 13.5751 19.5119 12.9088C18.8456 12.2426 17.942 11.8683 16.9998 11.8683C16.0576 11.8683 15.154 12.2426 14.4877 12.9088C13.8215 13.5751 13.4472 14.4787 13.4472 15.4209V19.6841M20.5524 19.6841C20.9293 19.6841 21.2908 19.8338 21.5573 20.1003C21.8238 20.3668 21.9735 20.7283 21.9735 21.1051V22.5262H12.0261V21.1051C12.0261 20.7283 12.1758 20.3668 12.4423 20.1003C12.7088 19.8338 13.0703 19.6841 13.4472 19.6841M20.5524 19.6841H16.9998H13.4472M23.3945 15.4209H24.1051M21.6182 10.092L21.263 10.4473M9.89453 15.4209H10.6051M16.9998 8.31567V9.0262M11.9757 10.3968L12.478 10.8991"
        stroke={theme.color.neutral_600}
        strokeWidth="1.02632"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

// 인포컨텐츠 말풍선 꼬리
export const BubbleForInfoContent: React.FC<{
  width?: string;
  height?: string;
}> = memo((props) => {
  const { width = 61, height = 61 } = props;
  return (
    <svg width={width} height={height}>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="640.05"
          id="filter0_d_1142_22940"
          width="521"
          x="0"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend in2="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1142_22940"
          />
        </filter>
      </defs>
      <g>
        <g filter="url(#filter0_d_1142_22940)" id="svg_1">
          <path
            clipRule="evenodd"
            d="m23,-601c-11.05,0 -20,8.95 -20,20l0,560.34c0,11.05 8.95,20 20,20l212.79,0c11.05,6.74 19.1,17.56 22.3,30.22c0.51,1.99 3.33,1.99 3.84,0c3.2,-12.66 11.24,-23.48 22.3,-30.22l211.77,0c11.05,0 20,-8.95 20,-20l0,-560.34c0,-11.05 -8.95,-20 -20,-20l-473,0z"
            fill="white"
            fillRule="evenodd"
            id="svg_2"
          />
        </g>
      </g>
    </svg>
  );
});

// 느낌표 (공지 리스트에서 사용자가 읽지 않은 컨텐츠 표시용)
export const ExclamationMark: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const {
    width = "20px",
    height = "20px",
    fill = theme.color.green_500,
  } = props;
  return (
    <svg
      height={height}
      width={width}
      version="1.1"
      id="_x32_"
      viewBox="0 0 512 512"
      fill={fill}
    >
      <g>
        <path
          d="M238.301,346.393c0.598,3.938,2.563,7.725,5.903,11.359c3.313,3.626,7.252,5.447,11.796,5.447
		c10.592,0,16.486-5.608,17.691-16.806l35.398-271.98c0.607-4.823,0.911-11.636,0.911-20.415c0-13.618-4.679-26.013-14.065-37.22
		C286.558,5.59,273.244,0,255.999,0c-17.868,0-31.317,5.742-40.389,17.226c-9.073,11.206-13.61,23.459-13.61,36.773
		c0,8.172,0.285,14.976,0.892,20.415L238.301,346.393z"
        />
        <path
          d="M295.033,418.065c-10.288-10.287-23.307-15.44-39.034-15.44c-15.422,0-28.441,5.314-39.032,15.896
		c-10.591,10.591-15.877,23.441-15.877,38.569c0,14.52,5.286,27.379,15.877,38.577C227.558,506.562,240.578,512,255.999,512
		c15.423,0,28.424-5.286,39.034-15.886c10.574-10.574,15.877-23.593,15.877-39.024C310.91,441.658,305.607,428.656,295.033,418.065z
		"
        />
      </g>
    </svg>
  );
});

// 점검중 화면 트랙터
export const MaintenanceTractorIcon: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "400px", height = "400px" } = props;
  return (
    <svg
      height={height}
      width={width}
      id="Layer_1"
      viewBox="0 0 511.975 511.975"
      fill={theme.color.black}
      style={{ transform: "scaleX(-1)" }}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <g>
          <path
            fill="#A4A4A4"
            d="M173.559,156.191c-4.799,0-8.678-3.888-8.678-8.678v-34.712c0-19.144,15.568-34.712,34.712-34.712 c4.799,0,8.678,3.888,8.678,8.678s-3.879,8.678-8.678,8.678c-9.572,0-17.356,7.784-17.356,17.356v34.712 C182.237,152.303,178.358,156.191,173.559,156.191"
          />
          <path
            fill="#535353"
            d="M503.322,399.174v-34.712h-7.09c-1.84-5.597-6.109-15.69-12.288-24.368l4.999-5.007l-16.991-16.991 l-5.007,4.999c-8.678-6.179-18.77-10.448-24.368-12.288v-7.09h-34.712v7.09c-5.597,1.84-15.69,6.109-24.368,12.288l-5.007-4.999 l-16.991,16.991l4.999,5.007c-6.179,8.678-10.448,18.77-12.288,24.368h-7.09v34.712h7.09c1.84,5.597,6.109,15.69,12.288,24.368 l-4.999,5.007l16.991,16.991l5.007-4.999c8.678,6.179,18.77,10.448,24.368,12.288v7.09h34.712v-7.09 c5.597-1.84,15.69-6.109,24.368-12.288l5.007,4.999l16.991-16.991l-4.999-5.007c6.179-8.678,10.448-18.77,12.288-24.368H503.322z"
          />
          <path
            fill="#A4A4A4"
            d="M459.932,381.818c0,19.17-15.542,34.712-34.712,34.712s-34.712-15.542-34.712-34.712 c0-19.17,15.542-34.712,34.712-34.712S459.932,362.648,459.932,381.818"
          />
          <path
            fill="#535353"
            d="M138.847,390.496c0,38.339-31.084,69.424-69.424,69.424S0,428.835,0,390.496 s31.084-69.424,69.424-69.424S138.847,352.157,138.847,390.496"
          />
          <path
            fill="#81C784"
            d="M313.878,364.462h-180.12c3.254,8.044,5.094,16.818,5.094,26.034c0,2.942-0.252,5.832-0.607,8.678 h175.633c-0.876-5.675-1.467-11.438-1.467-17.356S313.001,370.137,313.878,364.462"
          />
          <polygon
            fill="#535353"
            points="156.203,295.038 190.915,295.038 190.915,147.513 156.203,147.513 "
          />
          <g>
            <path
              fill="#81C784"
              d="M156.203,208.259H60.746c-19.17,0-34.712,15.542-34.712,34.712v17.356h130.169V208.259z"
            />
            <polygon
              fill="#81C784"
              points="190.915,260.326 260.339,260.326 260.339,208.259 190.915,208.259 "
            />
          </g>
          <path
            fill="#A4A4A4"
            d="M95.458,390.496c0,14.379-11.655,26.034-26.034,26.034S43.39,404.875,43.39,390.496 s11.655-26.034,26.034-26.034S95.458,376.116,95.458,390.496"
          />
          <path
            fill="#4CAF50"
            d="M260.339,52.055v156.203v52.068h-69.424v34.712h-34.712v-34.712H26.034v76.019 c11.889-9.537,26.962-15.273,43.39-15.273c29.132,0,54.029,17.955,64.33,43.39h180.12c3.02-19.491,10.969-37.315,22.623-52.163l0,0 c20.636-26.329,52.675-43.294,88.724-43.294c22.051,0,42.548,6.422,59.93,17.356l18.172-43.39V52.055H260.339z"
          />
          <g>
            <polygon
              fill="#9FD0F4"
              points="381.831,190.903 468.61,190.903 468.61,86.767 381.831,86.767 "
            />
            <polygon
              fill="#9FD0F4"
              points="260.339,190.903 347.119,190.903 347.119,86.767 260.339,86.767 "
            />
          </g>
          <g>
            <path
              fill="#81C784"
              d="M312.407,303.716h-43.39c-4.799,0-8.678-3.888-8.678-8.678c0-4.79,3.879-8.678,8.678-8.678h43.39 c4.799,0,8.678,3.888,8.678,8.678C321.085,299.828,317.206,303.716,312.407,303.716"
            />
            <path
              fill="#81C784"
              d="M286.373,338.428h-43.39c-4.799,0-8.678-3.888-8.678-8.678c0-4.79,3.879-8.678,8.678-8.678h43.39 c4.799,0,8.678,3.888,8.678,8.678C295.051,334.54,291.172,338.428,286.373,338.428"
            />
            <path
              fill="#81C784"
              d="M321.076,433.937c-3.393,0-6.621-2.005-8.01-5.337c-6.196-14.839-9.337-30.572-9.337-46.783 c0-66.994,54.498-121.492,121.492-121.492c31.501,0,61.362,12.002,84.081,33.801c3.463,3.315,3.575,8.817,0.26,12.271 c-3.324,3.462-8.808,3.575-12.271,0.26c-19.473-18.684-45.073-28.976-72.071-28.976c-57.422,0-104.136,46.714-104.136,104.136 c0,13.902,2.699,27.388,8.001,40.092c1.848,4.426-0.234,9.502-4.66,11.351C323.332,433.72,322.196,433.937,321.076,433.937"
            />
          </g>
        </g>
      </g>
    </svg>
  );
});

// 점검중 화면 트랙터 바퀴
export const MaintenanceTractorWheelIcon: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "150px", height = "150px" } = props;
  return (
    <svg
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512.002 512.002"
    >
      <g>
        <path
          fill="#666666"
          d="M268.91,11.601l0.106,1.042c1.457,13.903,20.913,15.951,25.256,2.666l0.327-1.024
		c4.829-14.786,26.906-10.081,25.247,5.376l-0.097,0.927c-1.492,13.903,17.108,19.959,24.135,7.865l0.512-0.874
		c7.812-13.462,28.416-4.255,23.561,10.522l-0.238,0.706c-4.37,13.294,12.562,23.093,21.963,12.712l0.583-0.636
		c10.452-11.546,28.69,1.739,20.842,15.183l-0.265,0.459c-7.053,12.094,7.468,25.203,18.829,16.993l0.539-0.38
		c12.632-9.128,27.701,7.654,17.223,19.182l-0.212,0.23c-9.428,10.364,2.057,26.209,14.874,20.524l0.406-0.177
		c14.257-6.312,25.512,13.233,12.853,22.334l-0.106,0.071c-11.388,8.192-3.443,26.077,10.284,23.164l0.221-0.044
		c15.272-3.24,22.219,18.22,7.945,24.505l-0.018,0.009c-12.853,5.658-8.792,24.797,5.252,24.788h0.071
		c15.607-0.018,17.964,22.404,2.684,25.609l0,0c-13.745,2.887-13.745,22.457,0,25.335l0,0c15.281,3.204,12.924,25.626-2.684,25.609
		h-0.071c-14.045-0.009-18.105,19.129-5.252,24.788l0.018,0.009c14.274,6.285,7.327,27.745-7.945,24.505l-0.221-0.044
		c-13.727-2.913-21.672,14.972-10.284,23.164l0.106,0.071c12.659,9.101,1.404,28.646-12.853,22.334l-0.406-0.177
		c-12.818-5.685-24.302,10.161-14.874,20.524l0.212,0.23c10.478,11.529-4.59,28.31-17.223,19.182l-0.539-0.38
		c-11.361-8.21-25.882,4.899-18.829,16.993l0.265,0.459c7.848,13.444-10.39,26.73-20.842,15.183l-0.583-0.636
		c-9.401-10.381-26.333-0.583-21.963,12.712l0.238,0.706c4.855,14.786-15.748,23.985-23.561,10.523l-0.512-0.874
		c-7.027-12.094-25.626-6.038-24.135,7.865l0.097,0.927c1.66,15.457-20.418,20.171-25.247,5.376l-0.327-1.015
		c-4.343-13.294-23.799-11.246-25.256,2.657l-0.106,1.042c-1.624,15.466-24.196,15.466-25.812,0l-0.115-1.042
		c-1.457-13.903-20.913-15.951-25.247-2.657l-0.335,1.015c-4.82,14.795-26.898,10.081-25.247-5.376l0.106-0.927
		c1.483-13.903-17.117-19.959-24.135-7.865l-0.512,0.874c-7.812,13.462-28.425,4.264-23.561-10.523l0.23-0.706
		c4.37-13.294-12.562-23.093-21.954-12.712l-0.583,0.636c-10.452,11.546-28.69-1.739-20.851-15.183l0.274-0.459
		c7.053-12.094-7.477-25.203-18.829-16.993l-0.538,0.38c-12.632,9.128-27.71-7.654-17.223-19.182l0.212-0.23
		c9.428-10.364-2.057-26.209-14.883-20.524l-0.397,0.177c-14.257,6.312-25.512-13.233-12.853-22.334l0.106-0.071
		c11.388-8.192,3.443-26.077-10.293-23.164l-0.221,0.044c-15.263,3.24-22.21-18.22-7.936-24.505l0.018-0.009
		c12.844-5.659,8.783-24.797-5.252-24.788h-0.079c-15.607,0.018-17.955-22.404-2.684-25.609l0,0
		c13.745-2.878,13.745-22.449,0-25.335l0,0c-15.272-3.204-12.924-25.626,2.684-25.609h0.079
		c14.036,0.009,18.097-19.129,5.252-24.788l-0.018-0.009c-14.274-6.285-7.327-27.745,7.936-24.505l0.221,0.044
		c13.736,2.913,21.681-14.972,10.293-23.164l-0.106-0.071c-12.659-9.101-1.404-28.646,12.853-22.334l0.397,0.177
		c12.826,5.685,24.311-10.161,14.883-20.524l-0.212-0.23C54.09,90.793,69.168,74.012,81.8,83.139l0.538,0.38
		c11.352,8.21,25.882-4.899,18.829-16.993l-0.274-0.459c-7.839-13.444,10.399-26.73,20.851-15.183l0.583,0.636
		c9.393,10.381,26.324,0.583,21.954-12.712l-0.23-0.706c-4.864-14.777,15.748-23.985,23.561-10.522l0.512,0.874
		c7.018,12.094,25.618,6.038,24.135-7.865l-0.106-0.927c-1.651-15.457,20.427-20.162,25.247-5.376l0.335,1.024
		c4.334,13.286,23.79,11.238,25.247-2.666l0.115-1.042C244.713-3.865,267.285-3.865,268.91,11.601"
        />
        <path
          fill="#B3B3B3"
          d="M370.761,256.001c0,63.382-51.377,114.759-114.759,114.759s-114.759-51.377-114.759-114.759
		s51.377-114.759,114.759-114.759S370.761,192.619,370.761,256.001"
        />
        <g>
          <path
            fill="#666666"
            d="M282.485,256.001c0,14.627-11.855,26.483-26.483,26.483c-14.627,0-26.483-11.855-26.483-26.483
			c0-14.627,11.855-26.483,26.483-26.483C270.629,229.518,282.485,241.374,282.485,256.001"
          />
          <path
            fill="#666666"
            d="M264.83,185.38c0,4.873-3.955,8.828-8.828,8.828s-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828
			S264.83,180.508,264.83,185.38"
          />
          <path
            fill="#666666"
            d="M264.83,326.622c0,4.873-3.955,8.828-8.828,8.828s-8.828-3.955-8.828-8.828
			s3.955-8.828,8.828-8.828S264.83,321.749,264.83,326.622"
          />
          <path
            fill="#666666"
            d="M326.623,264.829c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828
			c4.873,0,8.828,3.955,8.828,8.828C335.45,260.874,331.495,264.829,326.623,264.829"
          />
          <path
            fill="#666666"
            d="M185.381,264.829c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828
			c4.873,0,8.828,3.955,8.828,8.828C194.209,260.874,190.254,264.829,185.381,264.829"
          />
          <path
            fill="#666666"
            d="M312.181,212.307c-3.452,3.452-9.039,3.452-12.482,0c-3.452-3.452-3.452-9.039,0-12.482
			c3.443-3.452,9.031-3.452,12.482,0C315.632,203.268,315.632,208.856,312.181,212.307"
          />
          <path
            fill="#666666"
            d="M212.308,312.18c-3.452,3.452-9.039,3.452-12.482,0c-3.452-3.452-3.452-9.039,0-12.482
			c3.443-3.452,9.031-3.452,12.482,0C215.76,303.14,215.76,308.728,212.308,312.18"
          />
          <path
            fill="#666666"
            d="M299.696,312.18c-3.452-3.452-3.452-9.039,0-12.482c3.452-3.452,9.039-3.452,12.482,0
			c3.452,3.443,3.452,9.031,0,12.482C308.735,315.631,303.147,315.631,299.696,312.18"
          />
          <path
            fill="#666666"
            d="M199.823,212.307c-3.452-3.452-3.452-9.039,0-12.482c3.452-3.452,9.039-3.452,12.482,0
			c3.452,3.443,3.452,9.031,0,12.482C208.863,215.759,203.275,215.759,199.823,212.307"
          />
        </g>
      </g>
    </svg>
  );
});

//관리 아이콘
export const ManagementIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = (props) => {
  const { width = "109px", height = "145px", fill = "none"} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 109 145" fill="#E0E0E0" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M28.4108 9.85H14.225C10.6645 9.85 7.24981 11.2644 4.73214 13.7821C2.21446 16.2998 0.800049 19.7145 0.800049 23.275V130.675C0.800049 134.236 2.21446 137.65 4.73214 140.168C7.24981 142.686 10.6645 144.1 14.225 144.1H94.775C98.3356 144.1 101.75 142.686 104.268 140.168C106.786 137.65 108.2 134.236 108.2 130.675V23.275C108.2 19.7145 106.786 16.2998 104.268 13.7821C101.75 11.2644 98.3356 9.85 94.775 9.85H80.5893C79.6635 7.23142 77.9483 4.96444 75.6801 3.3615C73.412 1.75855 70.7025 0.89854 67.925 0.899996H41.075C38.2976 0.89854 35.5881 1.75855 33.32 3.3615C31.0518 4.96444 29.3366 7.23142 28.4108 9.85ZM41.075 9.85H67.925C69.1119 9.85 70.2501 10.3215 71.0894 11.1607C71.9286 11.9999 72.4 13.1382 72.4 14.325C72.4 15.5118 71.9286 16.6501 71.0894 17.4893C70.2501 18.3285 69.1119 18.8 67.925 18.8H41.075C39.8882 18.8 38.75 18.3285 37.9107 17.4893C37.0715 16.6501 36.6 15.5118 36.6 14.325C36.6 13.1382 37.0715 11.9999 37.9107 11.1607C38.75 10.3215 39.8882 9.85 41.075 9.85ZM45.55 59.075C45.55 57.8881 46.0215 56.7499 46.8607 55.9107C47.7 55.0715 48.8382 54.6 50.025 54.6H81.35C82.5369 54.6 83.6751 55.0715 84.5144 55.9107C85.3536 56.7499 85.8251 57.8881 85.8251 59.075C85.8251 60.2618 85.3536 61.4001 84.5144 62.2393C83.6751 63.0785 82.5369 63.55 81.35 63.55H50.025C48.8382 63.55 47.7 63.0785 46.8607 62.2393C46.0215 61.4001 45.55 60.2618 45.55 59.075ZM45.55 85.925C45.55 84.7382 46.0215 83.5999 46.8607 82.7607C47.7 81.9215 48.8382 81.45 50.025 81.45H81.35C82.5369 81.45 83.6751 81.9215 84.5144 82.7607C85.3536 83.5999 85.8251 84.7382 85.8251 85.925C85.8251 87.1118 85.3536 88.2501 84.5144 89.0893C83.6751 89.9285 82.5369 90.4 81.35 90.4H50.025C48.8382 90.4 47.7 89.9285 46.8607 89.0893C46.0215 88.2501 45.55 87.1118 45.55 85.925ZM45.55 112.775C45.55 111.588 46.0215 110.45 46.8607 109.611C47.7 108.771 48.8382 108.3 50.025 108.3H81.35C82.5369 108.3 83.6751 108.771 84.5144 109.611C85.3536 110.45 85.8251 111.588 85.8251 112.775C85.8251 113.962 85.3536 115.1 84.5144 115.939C83.6751 116.779 82.5369 117.25 81.35 117.25H50.025C48.8382 117.25 47.7 116.779 46.8607 115.939C46.0215 115.1 45.55 113.962 45.55 112.775ZM36.6 59.075C36.6 60.8553 35.8928 62.5626 34.634 63.8214C33.3752 65.0803 31.6678 65.7875 29.8875 65.7875C28.1073 65.7875 26.3999 65.0803 25.1411 63.8214C23.8823 62.5626 23.175 60.8553 23.175 59.075C23.175 57.2947 23.8823 55.5874 25.1411 54.3285C26.3999 53.0697 28.1073 52.3625 29.8875 52.3625C31.6678 52.3625 33.3752 53.0697 34.634 54.3285C35.8928 55.5874 36.6 57.2947 36.6 59.075ZM36.6 85.925C36.6 87.7053 35.8928 89.4126 34.634 90.6714C33.3752 91.9303 31.6678 92.6375 29.8875 92.6375C28.1073 92.6375 26.3999 91.9303 25.1411 90.6714C23.8823 89.4126 23.175 87.7053 23.175 85.925C23.175 84.1447 23.8823 82.4374 25.1411 81.1785C26.3999 79.9197 28.1073 79.2125 29.8875 79.2125C31.6678 79.2125 33.3752 79.9197 34.634 81.1785C35.8928 82.4374 36.6 84.1447 36.6 85.925ZM29.8875 119.487C28.1073 119.487 26.3999 118.78 25.1411 117.521C23.8823 116.263 23.175 114.555 23.175 112.775C23.175 110.995 23.8823 109.287 25.1411 108.029C26.3999 106.77 28.1073 106.062 29.8875 106.062C31.6678 106.062 33.3752 106.77 34.634 108.029C35.8928 109.287 36.6 110.995 36.6 112.775C36.6 114.555 35.8928 116.263 34.634 117.521C33.3752 118.78 31.6678 119.487 29.8875 119.487Z" 
        fill={fill}
      />
    </svg>
  );
};

// 공지 자세히 보기 아이콘
export const NoticeDetail: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "20px", height = "20px", fill = "#000000" } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 512 512" version="1.1">
      <path
        d="M 305.500 90.946 C 241.767 98.350, 192.040 143.366, 178.375 206.027 C 175.718 218.208, 175.712 250.908, 178.364 263 C 184.436 290.686, 196.777 314.273, 215.376 333.736 C 236.600 355.947, 261.116 369.654, 291.312 376.194 C 304.849 379.125, 332.845 379.367, 346.346 376.668 C 363.963 373.146, 382.238 366.009, 395.769 357.366 C 398.668 355.515, 401.430 354, 401.907 354 C 402.385 354, 414.625 367.612, 429.106 384.250 C 443.587 400.887, 456.728 415.731, 458.308 417.236 C 464.780 423.399, 474.068 423.127, 480.655 416.582 C 485.647 411.621, 487.109 405.590, 484.710 399.848 C 483.904 397.920, 470.608 381.849, 455.162 364.133 L 427.079 331.923 434.832 321.711 C 447.588 304.910, 456.984 284.327, 461.633 263 C 464.282 250.845, 464.282 218.138, 461.631 206.027 C 448.884 147.773, 404.604 104.119, 346.920 92.937 C 335.560 90.735, 315.583 89.774, 305.500 90.946 M 33.898 114.258 C 30.155 116.745, 26 123.975, 26 128 C 26 132.025, 30.155 139.255, 33.898 141.742 L 37.296 144 106.500 144 L 175.704 144 179.010 141.750 C 184.688 137.885, 186.500 134.560, 186.500 128 C 186.500 121.440, 184.688 118.115, 179.010 114.250 L 175.704 112 106.500 112 L 37.296 112 33.898 114.258 M 304.500 124.109 C 295.056 125.469, 281.250 129.701, 272.185 134.014 C 213.485 161.942, 191.104 233.675, 223.420 290.315 C 238.463 316.679, 262.883 334.907, 294.409 343.302 C 301.321 345.143, 305.123 345.449, 320.500 345.401 C 340.381 345.340, 346.053 344.300, 362.493 337.699 C 379.579 330.839, 399.052 315.647, 409.920 300.700 C 442.257 256.225, 437.645 194.887, 399.063 156.306 C 374.020 131.263, 338.583 119.197, 304.500 124.109 M 34.848 199.003 C 29.663 201.763, 26.571 207.203, 26.571 213.563 C 26.571 219.463, 28.240 222.555, 33.650 226.683 L 37.342 229.500 83.921 229.779 L 130.500 230.058 134.992 227.779 C 146.489 221.946, 147.352 207.504, 136.678 199.592 C 133.917 197.546, 132.811 197.495, 86.178 197.279 C 40.636 197.068, 38.336 197.145, 34.848 199.003 M 37.594 283.025 C 33.355 284.316, 28.118 289.848, 26.920 294.299 C 24.974 301.525, 28.200 309.058, 34.837 312.788 C 38.770 314.998, 38.811 315, 95.570 315 C 150.973 315, 152.474 314.949, 156.647 312.929 C 165.423 308.680, 168.393 297.137, 162.648 289.605 C 156.881 282.044, 161.141 282.521, 97.545 282.320 C 66.170 282.221, 39.192 282.538, 37.594 283.025"
        stroke="none"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
});

// 프린트 아이콘
export const PrintIcon: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "20px", height = "20px", fill = "#000000" } = props;
  return (
    <svg
      stroke="currentColor"
      fill={fill}
      strokeWidth="0"
      viewBox="0 0 512 512"
      height={height}
      width={width}
    >
      <path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"></path>
    </svg>
  );
});

// 검색바 엑스(삭제) 버튼
export const RemoveButton: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const {
    width = "15px",
    height = "15px",
    fill = theme.color.neutral_400,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.9925 0C10.86 0 14.0044 3.14438 14.0044 7.01188C14.0044 10.8794 10.86 14.0044 6.9925 14.0044C3.125 14.0044 0 10.8794 0 7.01188C0 3.14438 3.125 0 6.9925 0ZM7.03125 8.0275L9.25813 10.2738C9.53188 10.5475 9.98062 10.5475 10.2544 10.2738C10.5081 10.02 10.5081 9.57063 10.2544 9.29688L8.0275 7.05062L10.2544 4.80438C10.5081 4.53063 10.5081 4.08187 10.2544 3.8275C9.98062 3.55375 9.53188 3.55375 9.25813 3.8275L7.03125 6.07375L4.80437 3.8275C4.53062 3.55375 4.08187 3.55375 3.80813 3.8275C3.55437 4.08125 3.55437 4.53063 3.80813 4.80438L6.035 7.05062L3.80813 9.29688C3.55437 9.57063 3.55437 10.0194 3.80813 10.2738C4.08187 10.5475 4.53062 10.5475 4.80437 10.2738L7.03125 8.0275Z"
        fill={fill}
      />
    </svg>
  );
});

// 복사하기 버튼
export const CopyButton: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const {
    width = "20px",
    height = "20px",
    fill = theme.color.green_500,
  } = props;
  return (
    <svg
      fill={fill}
      width={width}
      height={height}
      viewBox="0 0 200 200"
      id="Layer_1"
    >
      <title />
      <path d="M145,17.5H90a30.09,30.09,0,0,0-30,30H55a30.09,30.09,0,0,0-30,30v75a30.09,30.09,0,0,0,30,30h55a30.09,30.09,0,0,0,30-30h5a30.09,30.09,0,0,0,30-30v-75a30.09,30.09,0,0,0-30-30Zm-25,135a10,10,0,0,1-10,10H55a10,10,0,0,1-10-10v-75a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10Zm35-30a10,10,0,0,1-10,10h-5v-55a30.09,30.09,0,0,0-30-30H80a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10v75Zm-55,10H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Zm0-30H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Z" />
    </svg>
  );
});

// 유저 추가하기 버튼
export const AddUserButton: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "20px", height = "20px", fill = "#fff" } = props;
  return (
    <svg
      stroke="currentColor"
      fill={fill}
      strokeWidth="0"
      viewBox="0 0 640 512"
      height={height}
      width={width}
    >
      <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"></path>
    </svg>
  );
});

// 기기 추가하기 버튼
export const AddMobileButton: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
}> = memo((props) => {
  const { width = "20px", height = "20px", fill = "#fff" } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15V18M17 21V18M17 18H14M17 18H20"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

// 전복사고 알림 끄기 버튼
export const MuteButton: React.FC<{
  width?: string;
  height?: string;
  fill?: string;
  onClick?: () => void;
}> = memo((props) => {
  const {
    width = "25px",
    height = "25px",
    fill = theme.color.red_400,
    onClick,
  } = props;
  return (
    <XButtonDivBox
      style={{ cursor: "pointer", width: width, height: height }}
      onClick={onClick}
    >
      <svg
        width={width}
        height={height}
        fill={fill}
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
      >
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2m6-11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23L18 13.1zM5.41 3.35 4 4.76l2.81 2.81C6.29 8.57 6 9.73 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h12.83l1.74 1.74 1.41-1.41z"></path>
      </svg>
    </XButtonDivBox>
  );
});

// 빼기모양 아이콘
export const MinusIcon = memo(
  ({
    width = "25px",
    height = "25px",
    fill = theme.color.neutral_400,
  }: {
    width?: string;
    height?: string;
    fill?: string;
  }) => {
    return (
      <svg
        width={width}
        height={height}
        fill={fill}
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M19 13H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1"
        ></path>
      </svg>
    );
  }
);

// 네모모양 아이콘
export const SquarIcon = memo(
  ({
    width = "25px",
    height = "25px",
    fill = theme.color.neutral_400,
  }: {
    width?: string;
    height?: string;
    fill?: string;
  }) => {
    return (
      <svg
        width={width}
        height={height}
        fill={fill}
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
      >
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1"></path>
      </svg>
    );
  }
);

export const BubbleTailIcon = memo(
  ({
    width = "50px",
    height = "35px",
  }: {
    width?: string;
    height?: string;
  }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 69 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_83_16806)">
          <path
            d="M35.9239 34.7786C35.4206 36.7666 32.5963 36.7666 32.093 34.7786V34.7786C28.5199 20.6638 18.9305 8.82911 5.86307 2.40733L2.99931 0.99998L65.0176 0.999992L62.1538 2.40734C49.0864 8.82911 39.497 20.6638 35.9239 34.7786V34.7786Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_83_16806"
            x="0"
            y="-1.52588e-05"
            width="68.0176"
            height="41.2696"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={"0"} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_83_16806"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_83_16806"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
);

export const FileDownloadIcon = memo(
  ({
    width = "24px",
    height = "24px",
    color = theme.color.black,
  }: {
    width?: string;
    height?: string;
    color?: string;
  }) => {
    return (
      <svg width={width} height={height} viewBox="0 0 24 24" fill={color}>
        <path d="M18 2h-7.17c-.53 0-1.04.21-1.42.59L4.59 7.41C4.21 7.79 4 8.3 4 8.83V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6.35 14.65-2.79-2.79c-.32-.32-.1-.86.35-.86H11v-2.99c0-.55.44-.99.99-1 .56-.01 1.01.44 1.01 1V13h1.79c.45 0 .67.54.35.85l-2.79 2.79c-.19.2-.51.2-.7.01"></path>
      </svg>
    );
  }
);

export const SitemapIcon = memo(
  ({
    width = 150,
    height = 150,
    fill = theme.color.neutral_200,
  }: {
    width?: number;
    height?: number;
    fill?: string;
  }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M35 28.75V31.25C35 33.3203 33.3203 35 31.25 35H28.75C26.6797 35 25 33.3203 25 31.25V28.75C25 26.6797 26.6797 25 28.75 25V20C28.75 19.6687 28.6187 19.35 28.3844 19.1156C28.15 18.8812 27.8313 18.75 27.5 18.75H18.75V25C20.8203 25 22.5 26.6797 22.5 28.75V31.25C22.5 33.3203 20.8203 35 18.75 35H16.25C14.1797 35 12.5 33.3203 12.5 31.25V28.75C12.5 26.6797 14.1797 25 16.25 25V18.75H7.5C6.80936 18.75 6.25 19.3094 6.25 20V25C8.32032 25 10 26.6797 10 28.75V31.25C10 33.3203 8.32032 35 6.25 35H3.75C1.67968 35 0 33.3203 0 31.25V28.75C0 26.6797 1.67968 25 3.75 25V20C3.75 17.9297 5.42968 16.25 7.5 16.25H16.25V12.5H11.25C9.17968 12.5 7.5 10.8203 7.5 8.75V3.75C7.5 1.67968 9.17968 0 11.25 0H23.75C25.8203 0 27.5 1.67968 27.5 3.75V8.75C27.5 10.8203 25.8203 12.5 23.75 12.5H18.75V16.25H27.5C29.5703 16.25 31.25 17.9297 31.25 20V25C33.3203 25 35 26.6797 35 28.75Z"
          fill={fill}
        />
      </svg>
    );
  }
);

// 비밀번호 초기화 아이콘
export const PwResetIcon = ({
  width = 23,
  height = 24,
  fill = theme.color.neutral_500,
}: {
  width?: number;
  height?: number;
  fill?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M8.50065 15.2854H14.501C15.208 15.2854 15.7866 14.7068 15.7866 13.9999V9.71421C15.7866 9.00727 15.208 8.42869 14.501 8.42869H14.0725V7.57167C14.0725 6.15295 12.9196 5 11.5009 5C10.0822 5 8.92921 6.15295 8.92921 7.57167V8.42869H8.50071C7.79376 8.42869 7.21519 9.00727 7.21519 9.71421V13.9999C7.21519 14.7068 7.7937 15.2854 8.50065 15.2854ZM11.5008 10.3567C11.9721 10.3567 12.3578 10.7424 12.3578 11.2137C12.3578 11.5307 12.1818 11.8007 11.9293 11.9508V12.9277C11.9293 13.1634 11.7364 13.3562 11.5008 13.3562C11.2651 13.3562 11.0723 13.1634 11.0723 12.9277V11.9508C10.8192 11.8007 10.6438 11.5307 10.6438 11.2137C10.6438 10.7424 11.0295 10.3567 11.5008 10.3567ZM9.78679 7.571C9.78679 6.62358 10.554 5.85702 11.5008 5.85702C12.4482 5.85702 13.2148 6.62425 13.2148 7.571V8.42802H9.78602L9.78679 7.571ZM13.2149 17.8564C13.2149 18.0921 13.022 18.2849 12.7864 18.2849H12.5333L12.7135 18.4609C12.8804 18.6279 12.8804 18.9021 12.7135 19.0696C12.6279 19.151 12.5206 19.1938 12.4091 19.1938C12.2976 19.1938 12.1903 19.151 12.109 19.0696L11.9288 18.8894V19.1425C11.9288 19.3782 11.7359 19.571 11.5003 19.571C11.2646 19.571 11.0718 19.3782 11.0718 19.1425V18.8894L10.8916 19.0696C10.8102 19.151 10.6987 19.1938 10.5914 19.1938C10.4842 19.1938 10.3727 19.151 10.2871 19.0696C10.1201 18.9027 10.1201 18.6285 10.2871 18.4609L10.4673 18.2849H10.2142C9.97851 18.2849 9.78565 18.0921 9.78565 17.8564C9.78565 17.6208 9.97851 17.4279 10.2142 17.4279H10.4673L10.2871 17.2477C10.1201 17.0808 10.1201 16.8108 10.2871 16.6432C10.454 16.4763 10.724 16.4763 10.8916 16.6432L11.0718 16.8234V16.5703C11.0718 16.3347 11.2646 16.1418 11.5003 16.1418C11.7359 16.1418 11.9288 16.3347 11.9288 16.5703V16.8234L12.109 16.6432C12.2759 16.4763 12.5459 16.4763 12.7135 16.6432C12.8804 16.8102 12.8804 17.0802 12.7135 17.2477L12.5333 17.4279H12.7864C13.022 17.4279 13.2149 17.6208 13.2149 17.8564ZM8.92926 17.8564C8.92926 18.0921 8.7364 18.2849 8.50076 18.2849H8.24763L8.42784 18.4609C8.59478 18.6279 8.59478 18.9021 8.42784 19.0696C8.34226 19.151 8.23498 19.1938 8.12348 19.1938C8.01197 19.1938 7.9047 19.151 7.81911 19.0696L7.64313 18.8894V19.1425C7.64313 19.3782 7.45027 19.571 7.21463 19.571C6.97899 19.571 6.78613 19.3782 6.78613 19.1425V18.8894L6.60592 19.0696C6.52456 19.151 6.41306 19.1938 6.30578 19.1938C6.19851 19.1938 6.087 19.151 6.00142 19.0696C5.83448 18.9027 5.83448 18.6285 6.00142 18.4609L6.18163 18.2849H5.9285C5.69286 18.2849 5.5 18.0921 5.5 17.8564C5.5 17.6208 5.69286 17.4279 5.9285 17.4279H6.17681L6.00083 17.2477C5.83389 17.0808 5.83389 16.8108 6.00083 16.6432C6.16777 16.4763 6.43778 16.4763 6.60533 16.6432L6.78554 16.8234V16.5703C6.78554 16.3347 6.9784 16.1418 7.21404 16.1418C7.44969 16.1418 7.64255 16.3347 7.64255 16.5703V16.8234L7.81853 16.6432C7.98547 16.4763 8.2597 16.4763 8.42724 16.6432C8.59418 16.8102 8.59418 17.0802 8.42724 17.2477L8.24703 17.4279H8.50015C8.7358 17.4279 8.92926 17.6208 8.92926 17.8564ZM17.0721 18.2855H16.819L16.9992 18.4615C17.1661 18.6285 17.1661 18.9027 16.9992 19.0702C16.9136 19.1516 16.8063 19.1944 16.6948 19.1944C16.5833 19.1944 16.476 19.1516 16.3947 19.0702L16.2145 18.89V19.1431C16.2145 19.3788 16.0216 19.5716 15.786 19.5716C15.5503 19.5716 15.3575 19.3788 15.3575 19.1431V18.89L15.1815 19.0702C15.0959 19.1516 14.9844 19.1944 14.8771 19.1944C14.7698 19.1944 14.6583 19.1516 14.5728 19.0702C14.4058 18.9033 14.4058 18.6291 14.5728 18.4615L14.753 18.2855H14.4998C14.2642 18.2855 14.0713 18.0927 14.0713 17.857C14.0713 17.6214 14.2642 17.4285 14.4998 17.4285H14.753L14.5728 17.2483C14.4058 17.0814 14.4058 16.8114 14.5728 16.6438C14.7397 16.4769 15.0139 16.4769 15.1815 16.6438L15.3575 16.824V16.5709C15.3575 16.3353 15.5503 16.1424 15.786 16.1424C16.0216 16.1424 16.2145 16.3353 16.2145 16.5709V16.824L16.3947 16.6438C16.5616 16.4769 16.8316 16.4769 16.9992 16.6438C17.1661 16.8108 17.1661 17.0808 16.9992 17.2483L16.8232 17.4285H17.0715C17.3071 17.4285 17.5 17.6214 17.5 17.857C17.5 18.0927 17.3077 18.2855 17.0721 18.2855Z"
        fill={fill}
      />
    </svg>
  );
};

// 삼각형안에 느낌표있는 경고 아이콘
export const WarnIcon = ({
  width = 26,
  height = 26,
  fill = theme.color.orange_200,
}: {
  width?: number;
  height?: number;
  fill?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      aria-hidden="true"
      viewBox="0 0 24 24"
    >
      <path d="M12 5.99 19.53 19H4.47zM2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0zM11 11v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1m0 5h2v2h-2z"></path>
    </svg>
  );
};

// 사이트맵 아이콘
export const SiteMapIcon: React.FC<{
  width?: number;
  height?: number;
  fill?: string;
}> = memo(
  ({ width = 150, height = 150, fill = theme.color.neutral_200 }) => {
    return (
      <svg width={width} height={height} viewBox="0 -0.5 17 17" >
      <g>
          <g>
            <path 
              fill={fill}
              d="M6.666,3.979 L9.333,3.979 C9.701,3.979 10,3.685 10,3.324 L10,0.698 C10,0.336 9.701,0.042 9.333,0.042 L6.666,0.042 C6.298,0.042 6,0.336 6,0.698 L6,3.324 C6,3.685 6.298,3.979 6.666,3.979 L6.666,3.979 Z">
            </path>
            <path
              fill={fill}
              d="M3.333,11.082 L0.666,11.082 C0.298,11.082 0,11.372 0,11.728 L0,14.312 C0,14.667 0.298,14.958 0.666,14.958 L3.333,14.958 C3.701,14.958 4,14.668 4,14.312 L4,11.728 C4,11.372 3.701,11.082 3.333,11.082 L3.333,11.082 Z">
            </path>
            <path 
              fill={fill}
              d="M9.333,11.082 L6.666,11.082 C6.298,11.082 6,11.372 6,11.728 L6,14.312 C6,14.667 6.298,14.958 6.666,14.958 L9.333,14.958 C9.701,14.958 10,14.668 10,14.312 L10,11.728 C10,11.372 9.701,11.082 9.333,11.082 L9.333,11.082 Z">
            </path>
            <path 
              fill={fill}
              d="M15.333,11.082 L12.666,11.082 C12.298,11.082 12,11.372 12,11.728 L12,14.312 C12,14.667 12.298,14.958 12.666,14.958 L15.333,14.958 C15.701,14.958 16,14.668 16,14.312 L16,11.728 C16,11.372 15.701,11.082 15.333,11.082 L15.333,11.082 Z">
            </path>
            <path 
              fill={fill}
              d="M2.953,8.958 L7.031,8.958 L7.031,9.938 L8.969,9.938 L8.969,8.958 L13.042,8.958 L13.042,9.938 L14.979,9.938 L14.979,7.031 L8.969,7.031 L8.969,5.016 L7.031,5.016 L7.031,7.031 L1.042,7.031 L1.042,9.938 L2.953,9.938 L2.953,8.958 Z">
            </path>
          </g>
      </g>
      </svg>
    );
  }
);

/*export const FileDownloadIcon = ({
  width = "24px",
  height = "24px",
  color = theme.color.black,
}: {
  width?: string;
  height?: string;
  color?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={color}>
      <path d="M18 2h-7.17c-.53 0-1.04.21-1.42.59L4.59 7.41C4.21 7.79 4 8.3 4 8.83V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6.35 14.65-2.79-2.79c-.32-.32-.1-.86.35-.86H11v-2.99c0-.55.44-.99.99-1 .56-.01 1.01.44 1.01 1V13h1.79c.45 0 .67.54.35.85l-2.79 2.79c-.19.2-.51.2-.7.01"></path>
    </svg>
  );
};*/
